import React from "react";
import styles from "./rajakundalini.module.css";
import { Box, Link, Modal, Typography } from "@mui/material";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Head from "next/head";
import Image from "next/image";

import block1 from "../../public/image/raja-kundalini/raja_kundalini_blck1_img.webp";
import block2 from "../../public/image/raja-kundalini/raja_kundalini_blck2_img.webp";
import block3 from "../../public/image/raja-kundalini/raja_kundalini_blck3_img.webp";
import block4 from "../../public/image/raja-kundalini/raja_kundalini_blck4_img.webp";
import block5 from "../../public/image/raja-kundalini/raja_kundalini_blck5_img.webp";
import block6 from "../../public/image/raja-kundalini/raja_kundalini_blck6_img.webp";
import block7 from "../../public/image/raja-kundalini/raja_kundalini_blck7_img.webp";
import block8 from "../../public/image/raja-kundalini/raja_kundalini_blck8_img.webp";
import block9 from "../../public/image/raja-kundalini/raja_kundalini_blck9_img.webp";
import block10 from "../../public/image/raja-kundalini/raja_kundalini_blck10_img.webp";
import block11 from "../../public/image/raja-kundalini/raja_kundalini_blck11_img.webp";
import block12 from "../../public/image/raja-kundalini/raja_kundalini_blck12_img.webp";
import block13 from "../../public/image/raja-kundalini/raja_kundalini_blck13_img.webp";
import block14 from "../../public/image/raja-kundalini/raja_kundalini_blck14_img.webp";
import block15 from "../../public/image/raja-kundalini/raja_kundalini_blck15_img.webp";
import block16 from "../../public/image/raja-kundalini/raja_kundalini_blck16_img.webp";
import block17 from "../../public/image/raja-kundalini/raja_kundalini_blck17_img.webp";
import block18 from "../../public/image/raja-kundalini/raja_kundalini_blck18_img.webp";
import block19 from "../../public/image/raja-kundalini/raja_kundalini_blck19_img.webp";
import block20 from "../../public/image/raja-kundalini/raja_kundalini_blck20_img.webp";
import block21 from "../../public/image/raja-kundalini/raja_kundalini_blck21_img.webp";
import block22 from "../../public/image/raja-kundalini/raja_kundalini_blck22_img.webp";
import block23 from "../../public/image/raja-kundalini/raja_kundalini_blck23_img.webp";
import block24 from "../../public/image/raja-kundalini/raja_kundalini_blck24_img.webp";
import block25 from "../../public/image/raja-kundalini/raja_kundalini_blck25_img.webp";
import block26 from "../../public/image/raja-kundalini/raja_kundalini_blck26_img.webp";
import block27 from "../../public/image/raja-kundalini/raja_kundalini_blck27_img.webp";
import block28 from "../../public/image/raja-kundalini/raja_kundalini_blck28_img.webp";
import block29 from "../../public/image/raja-kundalini/raja_kundalini_blck29_img.webp";
import block30 from "../../public/image/raja-kundalini/raja_kundalini_blck30_img.webp";
import block31 from "../../public/image/raja-kundalini/raja_kundalini_blck31_img.webp";
import block32 from "../../public/image/raja-kundalini/raja_kundalini_blck32_img.webp";
import block33 from "../../public/image/raja-kundalini/raja_kundalini_blck33_img.webp";
import block34 from "../../public/image/raja-kundalini/raja_kundalini_blck34_img.webp";
import block35 from "../../public/image/raja-kundalini/raja_kundalini_blck35_img.webp";
import block36 from "../../public/image/raja-kundalini/raja_kundalini_blck36_img.webp";
import block37 from "../../public/image/raja-kundalini/raja_kundalini_blck37_img.webp";
import block38 from "../../public/image/raja-kundalini/raja_kundalini_blck38_img.webp";
import block39 from "../../public/image/raja-kundalini/raja_kundalini_blck39_img.webp";
import block40 from "../../public/image/raja-kundalini/raja_kundalini_blck40_img.webp";
import block41 from "../../public/image/raja-kundalini/raja_kundalini_blck41_img.webp";

import muladharaRed from "../../public/image/raja-kundalini/muladhara_red_img.webp";
import muladharaRedCharacter from "../../public/image/raja-kundalini/muladhara_red_character_img.webp";

import muladharaSacral from "../../public/image/raja-kundalini/raja_kundalini_sacral_img.webp";
import muladharaSacralCharacter from "../../public/image/raja-kundalini/raja_kundalini_sacral_character_img.webp";

import solarPlexus from "../../public/image/raja-kundalini/raja_kundalini_solar_plexus_img.webp";
import solarPlexusCharacter from "../../public/image/raja-kundalini/raja_kundalini_solar_plexus_character_img.webp";

import heart from "../../public/image/raja-kundalini/raja_kundalini_heart_img.webp";
import heartCharacter from "../../public/image/raja-kundalini/raja_kundalini_heart_character_img.webp";

import throat from "../../public/image/raja-kundalini/raja_kundalini_throat_img.webp";
import throatCharacter from "../../public/image/raja-kundalini/raja_kundalini_throat_character_img.webp";

import thirdEye from "../../public/image/raja-kundalini/raja_kundalini_third_eye_img.webp";
import thirdEyeCharacter from "../../public/image/raja-kundalini/raja_kundalini_third_eye_character_img.webp";

import crown from "../../public/image/raja-kundalini/raja_kundalini_crown_img.webp";
import crownCharacter from "../../public/image/raja-kundalini/raja_kundalini_crown_character_img.webp";

import block49 from "../../public/image/raja-kundalini/raja_kundalini_blck49_img.webp";
import MysteryBannerNew from "../../components/MysteryBannerNew/MysteryBannerNew";


function index() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <>
      <Head>
        <title>Raja Kundalini | School of Our Divine Infinite Being</title>
      </Head>

      <div className={styles.raja_kundalini_page_main}>
        {/* {/ <!------Main Banner section-------> /} */}
        <div className={styles.raja_kundalini_bnr_main}>
          <div className={styles.perennial_mandalism_banner_main_wrpr}>
            <div className={styles.perennial_mandalism_banner_left}>
              <div className={styles.bannerLogo}>
                <span className={styles.logoviewlink} onClick={handleOpen}>
                  <img
                    src={`${process.env.cloud_url2}assets/images/viewicon.png`}
                  />
                </span>
                <img
                  src={`${process.env.cloud_url2}assets/images/logobanner.webp`}
                />
              </div>
              <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
              <h1 data-text="infinite being">INFINITE BEING</h1>

              <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
              <div
                className={`${styles.perennial_mandalism_bottombannerbg} ${styles.bannerboxtxt}`}
              >
                <div className={styles.yellow_bar}></div>
              </div>
            </div>
          </div>
        </div>

        <MysteryBannerNew/>

        {/* {/ <!------Main Block section-------> /} */}
        <div className={styles.raja_kundalini_page_blck_section_main}>
          <div className={styles.raja_kundalini_page_part1_main}>
            <div class={styles.common_width}>
              <div className={styles.orange_heading_section}>
                <div
                  className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
                >
                  <div className={styles.column}>
                    <div className={`${styles.col12} ${styles.bgifive}`}>
                      <h1>
                        Raja-Kundalini: Preparatory Alignment for the Practice
                        of Ritual Theurgy
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.blck_sec_common_width}>
              <div className={styles.blck1_main}>
                <div className={styles.image_section}>
                  <Image src={block1} alt="Block-1 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h4 className={styles.green_heading_25}>
                    Embodied Eternity through the Breath of the Cosmos
                  </h4>
                  <div className={styles.content_section}>
                    <p>
                      In our tradition, <span>Raja-Kundalini</span> is the name
                      we give to a sacred synthesis: the unification of{" "}
                      <span>
                        <i>Raja Yoga</i>
                      </span>
                      , rooted in Advaita Vedanta, with the esoteric energetics
                      of{" "}
                      <span>
                        <i>Tantric Kundalini Yoga</i>
                      </span>
                      . Together, they form a powerful path of preparatory
                      embodiment—a way of aligning the aspirant with their
                      eternal nature through the subtle body, in anticipation of
                      full theurgical engagement.
                    </p>

                    <p>
                      We want to make clear that Raja-Kundalini in and of itself
                      is a complete science. It is not merely a warm-up or a
                      preparatory routine, but a full path of divine embodiment
                      and union. Its fusion of Raja Yoga's disciplined awareness
                      with the luminous ascent of Kundalini Shakti creates a
                      sovereign method of spiritual realization—one that can
                      lead to profound transformation and inner awakening on its
                      own terms. While we present it here as a preliminary
                      alignment for ritual theurgy, it stands as a complete
                      sacred technology: refining the subtle body, clarifying
                      the witness consciousness, and revealing the divine as
                      both transcendent stillness and immanent pulse. For those
                      drawn to the path of embodied unity without ritual
                      invocation, Raja-Kundalini offers an ever-deepening spiral
                      into the mystery of one's own eternal nature.
                    </p>

                    <p>
                      Like theurgy, Raja-Kundalini is not merely a spiritual
                      technique. It is a training in becoming a living axis of
                      the divine pulse—an embodied expression of the great
                      cosmic circuit of procession and return. It awakens the{" "}
                      <span>
                        <i>ochêma</i>
                      </span>
                      , the soul’s star-chariot of light, and activates the
                      imaginal mandala of spherical being that mirrors the order
                      of the cosmos. While theurgy initiates one into divine
                      presence through ritual and invocation, Raja-Kundalini
                      brings the same presence inward through breath, vision,
                      subtle energetics, and meditative union.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck2_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block2} alt="Block-2 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <h4 className={styles.yellow_heading_20}>
                      As Gregory Shaw writes:
                    </h4>

                    <p>
                      <span>
                        “The Demiurge is an activity, specifically the activity
                        that divides the One and unifies the Many. For
                        Platonists, the Demiurge is the weaving of opposites,
                        the endless circling and pulse of procession and return
                        that creates our world... For theurgists, Nature is the
                        body of this god whose activity and breath they come to
                        recognize as their own... From this perspective... we
                        may turn to a different tradition... Tantra. I have been
                        struck by the remarkable similarities between Tantric
                        and theurgic practices as well as by parallels in their
                        respective metaphysical contexts.”
                      </span>
                    </p>

                    <p className={styles.left_align_italic}>
                      <span>
                        <i>
                          — Gregory Shaw, Platonic Tantra – Theurgists of Late
                          Antiquity
                        </i>
                      </span>
                    </p>

                    <p>
                      The practices outlined in this essay represent a
                      simplified and concentrated union of these two streams.
                      Raja-Kundalini serves to strengthen the light-body and
                      initiate the aspirant into a state of mandalic, spherical
                      embodiment. It is not a full system of either discipline
                      but a targeted orientation—a spiritual physiology of
                      ascent and descent through which one becomes a suitable
                      vessel for the divine operations of theurgical ritual.
                    </p>

                    <p>
                      We are not the first to suggest this convergence. Many
                      Western initiatic traditions have integrated yogic
                      disciplines with ritual magic. The Thelemic schools of
                      Aleister Crowley, the Theosophical work of Helena
                      Blavatsky, and the teachings of William Walker Atkinson
                      within the New Thought Movement all point toward this deep
                      synthesis.
                    </p>

                    <p>
                      <span>
                        “In formulaic expression, Advaita Vedanta seeks to
                        escape from desire; Tantra seeks to embrace desire… The
                        Vedantin’s way is one of withdrawal from the finite in
                        order to achieve a return to the infinite. This process,
                        however, from the Shaiva point of view is only the first
                        stage. The next stage is the outward journey from the
                        infinite to the finite. When perfection is achieved, man
                        participates in the universal vibration of the absolute
                        and shares in its essential both freedom.”
                      </span>
                    </p>

                    <p className={styles.left_align_italic}>
                      <span>
                        <i>
                          — Gregory Shaw, Platonic Tantra – Theurgists of Late
                          Antiquity
                        </i>
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck3_main}`}>
                <div className={styles.image_section}>
                  <Image src={block3} alt="Block-3 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <span>
                        “In Patanjali's Yoga and the later Samkhya schools,
                        liberation consists in the separation of the principle
                        of consciousness from the principle of matter in all its
                        dense and subtle forms.”
                      </span>
                    </p>

                    <p className={styles.left_align_italic}>
                      <span>
                        <i>
                          — Gregory Shaw, Platonic Tantra – Theurgists of Late
                          Antiquity
                        </i>
                      </span>
                    </p>

                    <p>
                      Raja Yoga, with its deep meditative stillness and
                      cultivation of non-attachment, aligns the practitioner
                      with the unconditioned source, the pure witness—Shiva in
                      Shaivite Tantra. It prepares the aspirant for the Tantric
                      descent—the energetic embodiment of Shakti and her upward
                      movement through the chakras. As Shaw notes, this movement
                      from Advaita to Tantra is not a contradiction but a
                      sequence.
                    </p>

                    <p>
                      Here, we provide a simplified meditation sequence from the
                      Raja tradition to initiate this stillness, followed by
                      Tantric Kundalini practices that awaken the imaginal light
                      body. Together, they form a complete cycle of ascension
                      and descent. We suggest that the aspirant engage this
                      Raja-Kundalini training consistently for several weeks
                      before entering the domain of full ritual theurgy.
                    </p>

                    <p>
                      <span>
                        “There are an abundant number of similarities between
                        theurgy and Tantra but perhaps the most revealing... is
                        that the physical senses are no longer obstacles to the
                        divine but portals by which the divine enters our world
                        and through which the soul becomes the vehicle of an
                        incarnating god.”
                      </span>
                    </p>

                    <p className={styles.left_align_italic}>
                      <span>
                        <i>
                          — Gregory Shaw, Platonic Tantra – Theurgists of Late
                          Antiquity
                        </i>
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck4_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block4} alt="Block-4 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <span>
                        “In the outward turn to the finite and material realm,
                        the Tantric initiate participates in the universal
                        vibration or pulse of the absolute. This... is
                        equivalent to the Iamblichean soul bestowing power,
                        life, and the activity of wholes to the finite parts of
                        the universe... In both systems the finite and material
                        is an expression of the infinite and invisible...
                        Through the chanting of mantras in Tantra and divine
                        names in theurgy the initiate unites with the gods
                        through their sounds... and become[s] that god in
                        embodied form... To enter this pulse of divine
                        activity... the initiate must first ascend to the divine
                        cause and then descend, having become identified with
                        the activity of the god."
                      </span>
                    </p>

                    <p className={styles.left_align_italic}>
                      <span>
                        <i>
                          — Gregory Shaw, Platonic Tantra – Theurgists of Late
                          Antiquity
                        </i>
                      </span>
                    </p>

                    <p>
                      In Tantric Kundalini practice, this is expressed through
                      the sacred union of Shiva and Shakti. Shiva is the eternal
                      witness—the knower and unmoved center—while Shakti is the
                      spherical, ascending power of ecstatic embodiment. Their
                      union is a visionary ritual of the soul, preparing the
                      practitioner for divine descent.
                    </p>

                    <p>
                      <span>
                        “Another shared principle of theurgy and Tantra is that
                        both traditions assert an unbroken continuity between
                        the immaterial and material worlds... Each soul has a
                        subtle body... the ochema of theurgists and the suksma
                        sharira of Tantra. In both traditions, the degree of
                        light in this subtle body is the index of the soul's
                        deification... As the subtle body becomes filled with
                        light it is also homologized to the cosmos, which allows
                        the soul to assume the body of a god.”
                      </span>
                    </p>

                    <p className={styles.left_align_italic}>
                      <span>
                        <i>
                          — Gregory Shaw, Platonic Tantra – Theurgists of Late
                          Antiquity
                        </i>
                      </span>
                    </p>

                    <p>
                      In our Central Doctrine, we teach the physics of the
                      Theurgic Ochêma—the spherical mandala or star vehicle—and
                      explore the photonic nature of the objective light body.
                      Modern physics, especially quantum theory, string theory,
                      and holographic models of the universe, affirm this
                      seamless continuum. What the ancients saw as the imaginal
                      body, we now understand as the informational substrate of
                      consciousness—the light-in-form.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck5_main}`}>
                <div className={styles.image_section}>
                  <Image src={block5} alt="Block-5 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      The purpose of both Raja-Kundalini and Theurgy is the
                      same: to intensify divine light, unveil the subtle body,
                      and awaken the god within. To fully appreciate the
                      metaphysical, psychological, and scientific basis of this
                      sacred art, we strongly encourage all aspirants to study
                      our Central Doctrine, where these teachings are integrated
                      and unfolded.
                    </p>

                    <p>
                      In the vision of the Tantrāloka, the path is not toward an
                      escape from the world but toward its transfiguration. All
                      things—body, breath, sound, desire, thought—are vehicles
                      of divine emergence. The practitioner does not rise{" "}
                      <span>
                        <i>out of</i>
                      </span>{" "}
                      embodiment, but rather into its secret luminosity. What
                      appears as form is, in truth, condensed light. What we
                      call self is but a wave crest of the great ocean of Citi,
                      the pulsating conscious force of Śiva–Śakti.
                    </p>

                    <p>
                      Abhinavagupta teaches that the subtle body{" "}
                      <span>
                        <i>(sūkṣma śarīra)</i>
                      </span>
                      , when awakened, is not a metaphor. It is a reality more
                      enduring than flesh, composed of the five pure elements{" "}
                      <span>
                        <i>(mahābhūtas)</i>
                      </span>{" "}
                      in their luminous, archetypal forms. When awareness is
                      internalized through the practices of{" "}
                      <span>
                        <i>Rāja-Kundalinī</i>
                      </span>
                      , the currents of prāṇa are drawn upward into the central
                      channel{" "}
                      <span>
                        <i>(suṣumṇā nāḍī)</i>
                      </span>
                      , where the divine power{" "}
                      <span>
                        <i>(Kundalinī Śakti)</i>
                      </span>{" "}
                      rests like a coiled serpent. Her awakening is the
                      uncoiling of cosmic memory—the remembrance that the soul
                      was never separate from God.
                    </p>

                    <p>
                      This awakening is called{" "}
                      <span>
                        <i>śaktipāta</i>
                      </span>
                      , the descent of divine power. It may arise gently or as a
                      sudden shock of lightning, depending on the maturity of
                      the soul. When{" "}
                      <span>
                        <i>śaktipāta</i>
                      </span>{" "}
                      occurs, the inner senses{" "}
                      <span>
                        <i>(divya indriyāṇi)</i>
                      </span>{" "}
                      begin to awaken, revealing realms of sound{" "}
                      <span>
                        <i>(nāda)</i>
                      </span>
                      , form{" "}
                      <span>
                        <i>(rūpa)</i>
                      </span>
                      , and vibration{" "}
                      <span>
                        <i>(spanda)</i>
                      </span>{" "}
                      that are inaccessible to ordinary perception. The
                      practitioner becomes a divya puruṣa—a divine
                      person—capable of abiding in simultaneous awareness of the
                      transcendent and immanent.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck6_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block6} alt="Block-6 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <h4 className={styles.yellow_heading_20}>
                      Abhinavagupta writes:
                    </h4>

                    <p>
                      <span>
                        "When the energy of awareness is gathered and elevated
                        by means of the upward breath, the inner fire is
                        kindled. That fire consumes the limitations of the ego,
                        illuminating the path to the Heart. In that Heart shines
                        the supreme light, more subtle than the subtlest ether,
                        from which all the worlds emerge and into which they
                        return."
                      </span>
                    </p>

                    <p className={styles.left_align_italic}>
                      <span>
                        <i>(Tantrāloka, I.263–265, paraphrased)</i>
                      </span>
                    </p>

                    <p>
                      In this light, the ochêma of the theurgist and the sūkṣma
                      śarīra of the Tantrika are not different. Both are radiant
                      architectures of the divine body—stars enfleshed in
                      consciousness. When intensified through practice, this
                      body becomes the vimāna, the vehicle of ascent and descent
                      between the human and divine orders. This is why the
                      Tantric adept and the theurgist alike can perform divine
                      acts: because they are not merely invoking divinity—they
                      are embodying it.
                    </p>

                    <p>
                      The subtle body, illumined by practice, is homologized to
                      the entire cosmos. Each chakra is a world, each breath a
                      creative act, each mantra a seed of the Absolute. As the{" "}
                      <span>
                        <i>Tantrāloka</i>
                      </span>{" "}
                      teaches, the perfected practitioner sees no difference
                      between mantra, deity, and self—
                      <span>
                        <i>mantra-rūpa-deva-ātmaikya</i>
                      </span>
                      . This is not poetic mysticism but lived gnosis.
                    </p>

                    <p>
                      The divine light{" "}
                      <span>
                        <i>(prakāśa)</i>
                      </span>{" "}
                      is not a symbol—it is the source substratum of all
                      appearance. The purpose of{" "}
                      <span>
                        <i>Rāja-Kundalinī</i>
                      </span>{" "}
                      is to anchor this light, not as abstract awareness, but as
                      embodied intensity—a gnosis lived through breath, will,
                      and ecstatic repose. This is what prepares the soul for
                      the sacred descent of theurgy: the movement not only of
                      knowing the god, but becoming the living image of the god.
                    </p>

                    <p>
                      Thus, whether the aspirant follows the ascending current
                      of{" "}
                      <span>
                        <i>Rāja Yoga,</i>
                      </span>{" "}
                      the spiraling surge of Kundalinī Tantra, or the ritual
                      invocations of{" "}
                      <span>
                        <i>Theurgy,</i>
                      </span>{" "}
                      the aim is singular: to dwell consciously as a living
                      flame in the shrine of the cosmos.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck7_main}`}>
                <div className={styles.image_section}>
                  <Image src={block7} alt="Block-7 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h4 className={styles.green_heading_25}>
                    Practicing the Raja-Kundalini of our school will allow one
                    to:
                  </h4>

                  <div className={styles.content_section}>
                    <h5 className={styles.yellow_bullet_and_cont}>
                      Establish oneself as the conscious axis of experience.
                    </h5>
                    <p className={styles.padding_left}>
                      Cultivate the stable <span>“I”</span> consciousness—the
                      witnessing center of the soul—which in our tradition is
                      not the ego as separative identity, but the clarified
                      locus of awareness through which divine presence operates.
                      This becomes the sovereign foundation of the
                      theurgist/yogi’s being, capable of directing intention,
                      invocation, and receptivity to the gods.
                    </p>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      Train the attention in spherical concentration and
                      multidimensional embodiment.
                    </h5>
                    <p className={styles.padding_left}>
                      Develop the ability to concentrate not linearly, but
                      radially, anchoring one’s awareness within the subtle
                      mandala of the light-body. This refines the{" "}
                      <span>
                        <i>ochêma</i>
                      </span>
                      —the imaginal body—as a vessel for the descent of divine
                      energies, and links the desire for the Infinite with the
                      body’s inner architecture.
                    </p>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      Master the art of inner silence.
                    </h5>
                    <p className={styles.padding_left}>
                      Learn to still the mental fluctuations{" "}
                      <span>
                        <i>(vṛttis)</i>
                      </span>{" "}
                      entirely, entering profound states of receptive quietude.
                      This silence is not mere passivity but an active
                      threshold—the inner sanctum where divine presence reveals
                      itself. Without this foundation, ritual theurgy becomes
                      performance; with it, it becomes incarnation.
                    </p>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      Awaken and circulate psychodynamic energy.
                    </h5>
                    <p className={styles.padding_left}>
                      Develop sensitivity to the layered fields of vital force
                      (prāṇa) that move through the body, from the base of the
                      spine to the crown of the head. Learn to identify, purify,
                      and direct this energy as a sacred current, preparing the
                      subtle channels (nāḍīs) for the full activation of{" "}
                      <span>
                        <i>Kundalinī Śakti</i>
                      </span>
                      .
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck8_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block8} alt="Block-8 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <h5 className={styles.yellow_bullet_and_cont}>
                      Internalize and embody symbolic realities.
                    </h5>
                    <p className={styles.padding_left}>
                      Engage consciously with sacred symbols, mantras, and
                      visualizations—not as mere representations, but as
                      doorways into states of being. Through meditative
                      immersion, these symbols become{" "}
                      <span>
                        <i>embodied archetypes</i>
                      </span>
                      , awakening latent psychological dimensions and rooting
                      divine principles in somatic awareness.
                    </p>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      Initiate the relational awareness of the divine polarity.
                    </h5>
                    <p className={styles.padding_left}>
                      Begin to experience the alchemical union of Śiva{" "}
                      <span>
                        <i>(the witnessing consciousness)</i>
                      </span>{" "}
                      and Śakti{" "}
                      <span>
                        <i>(the pulsating force of creation)</i>
                      </span>{" "}
                      within. This is not just a conceptual understanding but a
                      felt dynamic—the merging of knower and known, stillness
                      and power, that opens the practitioner to relational
                      divinity and prepares them to encounter the gods as both
                      inner and transcendent realities.
                    </p>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      Ascend through the chakras as stages of divine
                      integration.
                    </h5>
                    <p className={styles.padding_left}>
                      Progressively rise through the energy centers{" "}
                      <span>
                        <i>(cakras)</i>
                      </span>
                      , not merely as energetic points, but as initiatory
                      thresholds of consciousness. Each chakra represents a
                      refinement of awareness, a psycho-spiritual
                      initiation—beginning from survival and desire, moving
                      through will, love, expression, vision, and culminating in
                      silent unity. In our Raja-Kundalini practice, this ascent
                      is not a ladder away from embodiment, but a spiral that
                      sacralizes embodiment—activating each center as a portal
                      of theurgy. As one ascends, the subtle body becomes
                      luminous, the senses become divine instruments, and the
                      practitioner begins to embody the rhythm of the cosmos
                      within their very spine. This is the awakening of the
                      sacred vertical axis—the living pillar of ascent and
                      descent through which the divine may flow in ritual
                      action.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck9_main}`}>
                <div className={styles.image_section}>
                  <Image src={block9} alt="Block-9 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h4 className={styles.green_heading_25}>
                    Raja Yoga and the Axis of the Theurgic Self
                  </h4>

                  <div className={styles.content_section}>
                    <p className={styles.padding_left}>
                      Raja Yoga is often associated with the Yoga Sutras of
                      Patanjali, a foundational text that outlines a profound
                      path of inner purification and spiritual ascent. Sometimes
                      referred to as Ashtanga Yoga, or the “eight-limbed path,”
                      Raja Yoga offers a systematic framework for refining the
                      body, disciplining the mind, and awakening the higher
                      faculties of consciousness. Each limb is not merely a step
                      but a deepening dimension of inward realization:
                    </p>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      Yama – Ethical Restraints:
                    </h5>
                    <p className={styles.padding_left}>
                      These are universal moral disciplines—non-violence
                      (ahimsa), truthfulness (satya), non-stealing (asteya),
                      celibacy or energetic continence (brahmacharya), and
                      non-possessiveness (aparigraha). Practicing these
                      principles purifies the field of relational life,
                      establishes harmony with the outer world, and calms the
                      karmic reverberations that obscure inner stillness. It
                      should be clearly understood, however, that the practice
                      of celibacy—like fasting—is preparatory. In the deeper
                      Tantric path of Kundalini, divine union between two beings
                      is not denied but celebrated. It becomes a conscious,
                      sacred expression of the same energy that celibacy
                      initially helps to refine and contain.
                    </p>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      Niyama – Personal Observances:
                    </h5>
                    <p className={styles.padding_left}>
                      These include purity (shaucha), contentment (santosha),
                      austerity (tapas), self-inquiry through study (svadhyaya),
                      and surrender to the divine (Ishvarapranidhana). These
                      inner disciplines begin the alchemical work on the psyche
                      itself, initiating a sanctification of daily life and
                      intention.
                    </p>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      Asana – Posture:
                    </h5>
                    <p className={styles.padding_left}>
                      More than physical flexibility, asana refers to the
                      cultivation of a stable, unmoving seat for consciousness.
                      The body becomes an axis of stillness, a sacred geometry
                      through which the life-force may flow unhindered, and the
                      mind find its center.
                    </p>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      Pranayama – Regulation of the Life-Force:
                    </h5>
                    <p className={styles.padding_left}>
                      Through control and expansion of the breath, pranayama
                      harmonizes the subtle energies (prana) of the body. This
                      practice refines the currents of vitality, stills the
                      nervous system, and prepares the practitioner to access
                      finer gradations of awareness.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck10_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block10} alt="Block-10 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <h5 className={styles.yellow_bullet_and_cont}>
                      Pratyahara – Withdrawal of the Senses:{" "}
                    </h5>
                    <p className={styles.padding_left}>
                      Here, attention is consciously withdrawn from the outer
                      sense-objects, not through suppression, but through
                      interiorization. The awareness begins to turn back on
                      itself, resting in the luminous quiet of the inner world.
                    </p>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      Dharana – Concentration:{" "}
                    </h5>
                    <p className={styles.padding_left}>
                      The mind, now steadied and inward, is trained to hold
                      itself on a single point—be it a mantra, an image, a
                      sensation, or the breath itself. This one-pointed focus
                      develops the psychic muscle that cuts through distraction
                      and dispersal.
                    </p>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      Dhyana – Meditation:{" "}
                    </h5>
                    <p className={styles.padding_left}>
                      As concentration deepens, a shift occurs—effort gives way
                      to flow. Dhyana is the sustained stream of awareness, a
                      silent witnessing beyond fluctuation. Here, the duality
                      between subject and object begins to dissolve.
                    </p>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      Samadhi – Absorption:{" "}
                    </h5>
                    <p className={styles.padding_left}>
                      The culmination of the eight limbs is the union of knower,
                      knowing, and known. In samadhi, the conditioned self
                      dissolves into pure consciousness. This is not an escape
                      from the world, but the radiant ground of being in which
                      all phenomena arise and return. It is the flowering of
                      silence, awareness, and presence into their indivisible
                      unity. In our system, samadhi in its royal form is not
                      merely a transient experience but the stabilized
                      realization that emerges only when the full path of
                      Raja-Kundalini has been integrated—when the psychic
                      centers have been illumined, the mind stilled, and the
                      divine current awakened throughout the subtle body.
                    </p>

                    <p>
                      In our system, we emphasize Raja Yoga as the foundational
                      discipline that prepares the whole being—body, mind, and
                      breath—for deeper spiritual activation. Special focus is
                      given to the middle limbs:{" "}
                      <span>Asana, Pranayama, Dharana,</span> and{" "}
                      <span>Dhyana,</span> as these constitute the core
                      capacities of stillness, energetic regulation, focused
                      attention, and interior awareness.
                    </p>

                    <p>
                      This preparatory curriculum is not abstract but embodied:
                      through repetition, breath work, inner visualization, and
                      silent absorption, the practitioner awakens the latent
                      faculties of spiritual perception. As the mind becomes
                      clear and the breath harmonious, the ground is laid for
                      higher forms of inner work. In this sense, Raja Yoga is
                      not simply a preliminary path—it is a subtle purification
                      and royal alignment, in which the practitioner learns to
                      dwell in the throne of their own consciousness, poised for
                      revelation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.raja_kundalini_page_part2_main}>
            <div className={styles.blck_sec_common_width}>
              <div className={`${styles.blck1_main} ${styles.blck11_main}`}>
                <div className={styles.image_section}>
                  <Image src={block11} alt="Block-11 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h4 className={styles.green_heading_25}>
                    The Theurgist/Yogi as a Center of Consciousness
                  </h4>

                  <div className={styles.content_section}>
                    <p>
                      William Walker Atkinson, in{" "}
                      <span>
                        <i>Raja Yoga</i>
                      </span>
                      , articulates a distinct and powerful perspective on this
                      ancient discipline, offering profound insight into the
                      structure and mastery of the mind as a vehicle for
                      spiritual awakening.
                    </p>

                    <p>
                      <span>
                        “He must be able to distinguish between the ‘I’ and the
                        ‘Not I.’ And this is the first task before the
                        Candidate… When the Real Self begins to awaken, it sets
                        aside from itself those things which are but appendages
                        to it… Setting aside first this, and then that, it
                        finally discards all of the ‘Not I,’ leaving the Real
                        Self free and delivered from its bondage to its
                        appendages.”
                      </span>
                    </p>

                    <p>
                      This foundational discernment—the ability to distinguish
                      the eternal self from fleeting impressions—is a vital
                      cornerstone in both Raja Yoga and Theurgy. In our work,
                      this is the movement from conditioned identity to{" "}
                      <span>the I of divine centeredness</span>, which mirrors
                      the{" "}
                      <span>
                        <i>Nous</i>
                      </span>{" "}
                      of Neoplatonism and the{" "}
                      <span>
                        <i>Atman</i>
                      </span>{" "}
                      of Vedanta. This realization is not abstract; it is
                      achieved through repetition, silence, breath, and posture.
                      It is a training of perception to unveil what was always
                      present.
                    </p>

                    <p>
                      <span>
                        “Let the Candidate… form in his mind the idea of himself
                        as a real thing, an actual being, an individual entity,
                        a Sun around which revolves the world… Until the Ego
                        recognizes itself as a Centre of Thought, Influence and
                        Power, it will not be able to manifest these qualities.”
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck12_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block12} alt="Block-12 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      This instruction aligns perfectly with our teaching that
                      the theurgist is a Cosmic Node, a point of divine focus
                      within the whole, whose meditative posture and clarity of
                      awareness activates ritual space and magnetizes the divine
                      intelligences. As such, Raja meditation is not just
                      preliminary—it is already participatory. The theurgist who
                      enters a ritual in silence, in stillness, with awakened
                      awareness, is one who has cultivated the inner Sun of
                      consciousness through Raja Yoga.
                    </p>

                    <p>
                      Swami Vivekananda, another powerful voice for Raja Yoga,
                      described this cultivation in terms strikingly similar to
                      our own framework:
                    </p>

                    <p>
                      <span>
                        “The mind can be controlled… It is only the trained mind
                        that brings us to Samadhi. But this training is not mere
                        intellectual effort; it is the centering of
                        consciousness into one continuous current, uninterrupted
                        by the senses.”
                      </span>
                    </p>

                    <p>
                      This continuity of awareness becomes the basis for divine
                      receptivity. Without it, ritual becomes mechanical; with
                      it, ritual becomes theurgy. What we are doing is not
                      merely suppressing thoughts, but disciplining awareness to
                      become a clear{" "}
                      <span>
                        <i>mirror</i>
                      </span>{" "}
                      in which divine intelligences may reflect their presence.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck13_main}`}>
                <div className={styles.image_section}>
                  <Image src={block13} alt="Block-13 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h4 className={styles.green_heading_25}>
                    The Holographic Self, Theurgic Mind, and Kundalini Fire
                  </h4>

                  <div className={styles.content_section}>
                    <p>
                      Our adaptation of Raja Yoga does not end with the
                      traditional Yogic goals of liberation or Samadhi—it is
                      oriented toward incarnating divine archetypes, awakening
                      and unifying the Shakti of dynamic becoming with the{" "}
                      <span>
                        <i>Shiva</i>
                      </span>{" "}
                      of witnessing stillness. The Raja disciplines prepare the
                      field of awareness for this unification, cultivating what
                      Atkinson calls the <span>“centre of power”</span> from
                      which the Kundalini force can rise with balance and
                      precision.
                    </p>

                    <p>
                      <span>
                        “In the Meditation simply ignore all consideration of
                        the respective qualities of others, and endeavor to
                        realize the fact that YOU are a great Centre of
                        Consciousness — a Centre of Power — a Centre of
                        Influence — a Centre of Thought. And that like the
                        planets circling around the sun, so does your world
                        revolve around YOU who are its centre.”
                      </span>
                    </p>

                    <p>
                      The metaphysical clarity of this image—of the
                      theurgist/yogi as a microcosmic Sun—is deepened in our
                      system through ritual praxis, planetary alignment, and
                      kundalini ascent. As you will see throughout this essay,
                      these ancient Yogic realizations are not separate from our
                      Western mystical path; they are its{" "}
                      <span>inner scaffolding</span>.
                    </p>

                    <p>
                      Our central doctrine further explores how this yogic
                      unfolding integrates quantum metaphysics, holographic
                      information theory, and Jungian archetypes—offering a map
                      where awareness, symbol, and energy converge. Raja Yoga is
                      the training of the inner axis upon which Theurgy spins,
                      and to cultivate it is to bring consciousness into perfect
                      readiness for divine encounter.
                    </p>

                    <p>
                      In this way, Raja Yoga is not simply preparatory—it is
                      itself a theurgical act: the invocation of the Self as
                      Divine Center.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck14_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block14} alt="Block-14 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <h4 className={styles.yellow_heading_20}>
                      Asana - Posture
                    </h4>

                    <p>
                      There are several postures found throughout the different
                      yogic practices. The two that our school recommends, both
                      appropriate for the practice of Raja-Kundalini. is the
                      lotus pose, or padmasana and vajrasana, sometimes referred
                      to as seiza pose, or seated dragon. These postures should
                      be practiced daily as a prerequisite to performing any of
                      the Theurgic rituals. You should continue these postures
                      in meditation until you can hold either of them
                      comfortably for 20 to 30 minutes at a time.
                    </p>

                    <h4 className={styles.yellow_heading_20}>
                      The Lotus Pose, or Padmasana
                    </h4>

                    <p>
                      The Lotus Pose, or Padmasana, is one of the most iconic
                      and recognized poses in yoga. It's a seated posture that
                      is often used for meditation and pranayama (breathing
                      exercises) in both yoga and Buddhist practices.
                    </p>

                    <p>
                      Here is a basic description of how to achieve the Lotus
                      Pose:
                    </p>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>1.</h5>
                      <p>
                        Start by sitting on the floor with your legs extended in
                        front of you. Keep your spine erect.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>2.</h5>
                      <p>
                        Bend your right knee and gently bring it closer to your
                        chest. Lift your right foot off the floor and hold onto
                        it with both hands.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>3.</h5>
                      <p>
                        Carefully place your right foot onto your left thigh.
                        The sole of your foot should be facing upwards, and the
                        heel should be close to your abdomen.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>4.</h5>
                      <p>
                        Now, repeat the same process with your left foot. Bend
                        your knee, lift the foot off the floor, and place it
                        onto your right thigh.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>5.</h5>
                      <p>
                        Once both feet are positioned on the opposite thighs,
                        place your hands onto your knees. You can form a circle
                        with your thumb and index finger (Gyan Mudra) with the
                        remaining fingers extended straight, or simply rest your
                        hands palms-down on your knees.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>6.</h5>
                      <p>
                        Keep your spine straight and elongate it. You should
                        relax your shoulders and soften your face.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck15_main}`}>
                <div className={styles.image_section}>
                  <Image src={block15} alt="Block-15 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <h4 className={styles.yellow_heading_20}>
                      The Seated Dragon or Vajrasana
                    </h4>

                    <p>
                      Vajrasana, sometimes referred to as Seiza Pose, is a
                      simple kneeling posture often used in yoga for meditation
                      and pranayama <span>(breathing exercises)</span>.{" "}
                      <span>"Vajra"</span> means <span>"thunderbolt"</span> or{" "}
                      <span>"diamond"</span> in Sanskrit, symbolizing the
                      strength and solidity this pose is believed to instill in
                      practitioners.
                    </p>

                    <p>Here's how you can get into Vajrasana:</p>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>1.</h5>
                      <p>
                        Start by kneeling on a yoga mat or soft surface, with
                        your legs and feet together. Your big toes should touch
                        each other.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>2.</h5>
                      <p>
                        Lower your buttocks so that they rest on your heels.
                        Your heels should be on either side of your buttocks.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>3.</h5>
                      <p>
                        Keep your spine and head straight, similar to the
                        natural alignment when standing. Your hands should rest
                        on your thighs, with palms down.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>4.</h5>
                      <p>
                        Close your eyes and take slow, deep breaths. Try to
                        maintain this pose for a few minutes, gradually
                        increasing the time as your comfort level improves.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck16_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block16} alt="Block-16 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <h4 className={styles.yellow_heading_20}>Pranayama</h4>

                    <p>
                      Pranayama refers to breathing exercises in yoga that help
                      to control and regulate the flow of Prana, or life force,
                      in the body. There are numerous Pranayama exercises. Here
                      are some examples of pranayama techniques:
                    </p>

                    <p>
                      <strong>Anulom Vilom</strong>{" "}
                      <span>(Alternate Nostril Breathing):</span> This involves
                      inhaling through one nostril, holding the breath, and then
                      exhaling through the other nostril. This is repeated with
                      the breath being inhaled from the other nostril, creating
                      a cycle.
                    </p>

                    <p>
                      <strong>Kapalabhati</strong>{" "}
                      <span>(Skull Shining Breath or Breath of Fire):</span> As
                      mentioned before, this technique involves forceful and
                      rapid exhalation with passive inhalation.
                    </p>

                    <p>
                      <strong>Bhastrika</strong> <span>(Bellows Breath):</span>{" "}
                      In this technique, both inhalation and exhalation are
                      forced and involve rapid abdominal movements similar to
                      panting.
                    </p>

                    <p>
                      <strong>Ujjayi</strong>{" "}
                      <span>(Victorious Breath or Ocean Breath):</span> This is
                      performed by constricting the back of the throat while
                      inhaling and exhaling, which creates a soothing sound like
                      the ocean's waves.
                    </p>

                    <p>
                      <strong>Brahmari</strong> <span>(Bee Breath):</span> In
                      this practice, a humming sound like a bee is made while
                      exhaling.
                    </p>

                    <p>
                      <strong>Sitali</strong> <span>(Cooling Breath):</span>{" "}
                      This involves curling the tongue and inhaling through the
                      mouth, followed by a long exhalation through the nose.
                    </p>

                    <p>
                      <strong>Simhasana</strong> <span>(Lion's Breath):</span>{" "}
                      Here, you inhale deeply through your nose, then open your
                      mouth wide and stick out your tongue as you exhale
                      forcefully.
                    </p>

                    <p>
                      The two that we recommend practicing one, then the other
                      before you begin your meditation as well as Theurgic
                      practices are the Kapalabhati and Bhastrika. Switching
                      from one for 20 seconds to the other for 20 seconds,
                      switching back and forth three times. Between each you
                      want to add in taking a deep breath and then holding it
                      with the sign of silence for a short period.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck17_main}`}>
                <div className={styles.image_section}>
                  <Image src={block17} alt="Block-17 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <h4 className={styles.yellow_heading_20}>Kapalabhati</h4>

                    <p>
                      The Breath of Fire, also known as Kapalabhati or Skull
                      Shining Breath, is a breathing technique used in various
                      forms of yoga, including Raja Yoga. It's a type of
                      Pranayama, which is the practice of breath control.
                    </p>

                    <p>Here is how you can do it:</p>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>1.</h5>
                      <p>
                        Sit in a comfortable position, preferably with your
                        spine straight. This could be in the lotus position or
                        just sitting comfortably on a chair.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>2.</h5>
                      <p>Rest your hands on your knees or in your lap.</p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>3.</h5>
                      <p>
                        Close your eyes and take a moment to center yourself.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>4.</h5>
                      <p>
                        Begin by exhaling forcefully through your nose. The
                        emphasis is on the exhale, while the inhale is more
                        passive and natural, not forced. When you exhale, you
                        should feel your lower belly draw back towards your
                        spine.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>5.</h5>
                      <p>
                        Continue this pattern of forceful exhales and passive
                        inhales. Aim to do about one exhale-inhale cycle per
                        second.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>6.</h5>
                      <p>
                        Start by practicing this for about a minute at a time.
                        As you become more comfortable with the technique, you
                        can gradually increase the duration.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck18_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block18} alt="Block-18 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <h4 className={styles.yellow_heading_20}>Bhastrika</h4>

                    <p>
                      Bhastrika, also known as Bellows Breath, is a powerful and
                      energizing pranayama <span>(breathing technique)</span>{" "}
                      practiced in yoga. The word <span>'Bhastrika'</span>{" "}
                      translates to <span>'bellows'</span> in Sanskrit, a device
                      used traditionally to fan fire, which is representative of
                      the effect this practice is said to have on the body's
                      inner energy.
                    </p>

                    <p>Here's a basic way to perform Bhastrika Pranayama:</p>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>1.</h5>
                      <p>
                        Sit in a comfortable position. You could sit
                        cross-legged on the floor or on a chair, as long as you
                        can keep your back straight.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>2.</h5>
                      <p>
                        Close your eyes and take a couple of deep, calming
                        breaths.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>3.</h5>
                      <p>
                        Inhale deeply and forcefully through both nostrils while
                        expanding your abdomen, and then quickly and forcefully
                        exhale, contracting your abdominal muscles. The
                        inhalation and exhalation should be of equal duration.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>4.</h5>
                      <p>
                        Continue this cycle of forceful inhalation and
                        exhalation at a rapid pace, just like a bellows fanning
                        a fire. Start with 10 to 20 cycles at a time.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>5.</h5>
                      <p>
                        After each round, return to normal breathing and observe
                        the sensations in your body.
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>6.</h5>
                      <p>
                        You can gradually increase the number of cycles per
                        round over time.
                      </p>
                    </div>

                    <p>
                      Bhastrika Pranayama is said to increase the flow of Prana
                      or life force in the body, stimulate the metabolism, and
                      produce warmth. It can invigorate the body and mind,
                      improve blood circulation, and help to clear the nadis
                      (energy channels) in preparation for the practices
                      prescribed here for Raja-Kundalini.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.raja_kundalini_page_part3_main}>
            <div className={styles.blck_sec_common_width}>
              <div className={`${styles.blck1_main} ${styles.blck19_main}`}>
                <div className={styles.image_section}>
                  <Image src={block19} alt="Block-19 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h4 className={styles.green_heading_25}>
                    Achieving the Raja pure awareness meditation of Śiva
                  </h4>
                  <div className={styles.content_section}>
                    <p>
                      <span>
                        “It is one of the most prominent doctrines of Raja Yoga
                        that the power of expelling thoughts, or if need be,
                        killing them dead on the spot, must be attained”.
                      </span>
                    </p>

                    <h6 className={styles.left_align_italic}>
                      <i>William Walker Attkionson, Raja Yoga</i>
                    </h6>

                    <p>
                      The following Raja meditation serves as a vital
                      preparation for both the awakening of Kundalinī and the
                      deeper dimensions of theurgic ritual praxis. Its purpose
                      is the establishment of pure awareness through the
                      dissolution of the false ego—everything mistakenly
                      identified as the self but which is, in truth, only an
                      expression or mode of being. What is not an aspect of the
                      true <span>“I”</span> must be set aside.
                    </p>

                    <p>
                      This is a silent practice. There are no mantras. Each
                      spoken pronouncement is followed by silence—because the
                      states of Raja must unfold in stillness. The goal is not
                      intellectual understanding but experiential realization:
                      abiding as pure awareness, unshaken, uncluttered,
                      sovereign.
                    </p>

                    <p>
                      This final meditation seals the path of Raja as the throne
                      of pure awareness—Śiva as the silent <span>"I,"</span>{" "}
                      untouched by movement, form, or time. It is here that the
                      yogin turns fully inward, beyond all manifestations, to
                      rest in the unconditioned Self: the Knower who has always
                      been.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck20_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block20} alt="Block-20 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      In our tradition, Raja is the sovereign foundation for the
                      greater unfolding of Raja-Kundalinī. Before the current of
                      divine power can rise through the system, the field must
                      be cleared, the center must be known. And that center is
                      not a place—it is a Presence: the silent, ever-witnessing
                      awareness behind all experience. This meditation brings
                      the practitioner into direct contact with that center. It
                      is the recognition of consciousness as consciousness, the
                      Self prior to its radiant expression as energy, mind, and
                      world.
                    </p>

                    <p>
                      Only when this realization is tasted can the journey of
                      Kundalinī begin in fullness. For it is Śiva—this very{" "}
                      <span>"I"</span> of awareness—that Shakti longs to unite
                      with. Without this grounding in the witness, the upward
                      current remains partial. But when the yogin knows,{" "}
                      <span>
                        “I am not the body, not the emotions, not the mind, not
                        the story—I am Awareness itself”
                      </span>
                      —then the vessel is ready, and the dance of Shakti can
                      commence in truth.
                    </p>

                    <p>
                      This meditation does not deny life; it reveals its source.
                      We do not reject the body, emotions, or mind—we simply
                      cease to mistake them for the Self. They are sacred
                      expressions of existence, but not its root. The root is
                      the silent, sovereign Self, watching through the eyes,
                      listening behind the ears, and abiding before and beyond
                      the heart.
                    </p>

                    <p>
                      To sit in Raja is to sit at the edge of the infinite. This
                      is the Śiva-state—the sky of mind emptied of clouds, the
                      still center untouched by the swirl of becoming. All
                      Tantric work to come rests upon this royal realization.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck21_main}`}>
                <div className={styles.image_section}>
                  <Image src={block21} alt="Block-21 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      Let your posture be strong, but open. Let your breath
                      become spacious and deep. Prepare now to peel back the
                      layers—body, emotion, thought, life—until only the Knower
                      remains.
                    </p>

                    <p>Not a thought. Not an image. Not even a feeling.</p>

                    <p>Only Awareness.</p>

                    <p>
                      This is Raja—the gate through which Raja-Kundalinī shall
                      rise.
                    </p>

                    <p>
                      Before entering this essential meditation of Raja, prepare
                      the body as the temple of stillness. The posture you
                      assume is not merely physical—it is an invocation of
                      presence. It signals to the body-mind system that
                      something sacred is about to unfold.
                    </p>

                    <p>
                      Sit in a chosen form—not for comfort alone, but for
                      alignment and activation. We recommend one of the
                      following postures, each bearing its own energetic
                      significance:
                    </p>

                    <p className={styles.bullet_cont}>
                      <strong>The Seated Dragon:</strong> A strong and rooted
                      posture, where one leg is folded beneath you and the other
                      knee is raised, with the foot planted firmly on the
                      ground. The spine ascends like a serpent coiled and ready,
                      the heart lifted and open. This form grounds instinct and
                      awakens ascent—a posture of alert repose and embodied
                      will.
                    </p>

                    <p className={styles.bullet_cont}>
                      <strong>Vajrāsana</strong>{" "}
                      <span>(Thunderbolt Pose):</span> Kneeling with the
                      buttocks resting on the heels, the spine straight, and
                      hands resting gently on the thighs. This pose stabilizes
                      the lower body and fosters digestive fire and mental
                      clarity—ideal for entering subtle states of awareness.
                    </p>

                    <p className={styles.bullet_cont}>
                      <strong>Padmāsana</strong> <span>(Lotus Pose):</span> The
                      classical yogic seat where each foot is placed on the
                      opposite thigh, forming a closed circuit that seals prāṇa
                      within. This posture symbolizes the union of opposites,
                      stillness in motion, and deep inner focus.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck22_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block22} alt="Block-22 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      Whichever seat you choose, let it become a mudrā of your
                      intention. Let the body settle, the breath deepen, and the
                      awareness gather itself inward. The meditation that
                      follows does not arise from effort alone, but from the
                      harmony of posture, breath, and presence—opening the inner
                      sanctum to the descent of the Real.
                    </p>

                    <p>
                      Choose the form that brings both stability and alertness.
                      The key is rootedness without tension. Your body must feel
                      like a throne, not a chair—a still base for the silent
                      witness to shine forth.
                    </p>

                    <p>
                      Place your hands in Jnana Mudra or resting gently on your
                      knees. Allow the spine to rise like a pillar of light.
                      Draw your attention inward.
                    </p>

                    <p>
                      Take several deep, intentional breaths. With each exhale,
                      release surface tensions. With each inhale, draw the
                      awareness inward toward the center behind all sensation.
                    </p>

                    <p>
                      Let the breath begin to soften and slow, not by force, but
                      by intimacy.
                    </p>

                    <p>Feel the field of awareness opening.</p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck23_main}`}>
                <div className={styles.image_section}>
                  <Image src={block23} alt="Block-23 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h4 className={styles.green_heading_25}>
                    Meditation of Unity - one and zero
                  </h4>

                  <div className={styles.content_section}>
                    <h5 className={styles.yellow_bullet_and_cont}>Aim</h5>
                    <div className={styles.padding_left}>
                      <p>
                        To entrain the Witness <span>(sākṣin)</span> as absolute
                        unity <span>(the 1)</span> while consciously holding the
                        boundless negative existence <span>(the 0)</span> that
                        surrounds it. This practice stabilizes one-pointed
                        awareness and trains the mind-breath field to rest
                        simultaneously in Being and Non-Being.
                      </p>
                    </div>

                    <h5 className={styles.yellow_bullet_and_cont}>Duration</h5>
                    <div className={styles.padding_left}>
                      <p>
                        8–15 minutes per sitting{" "}
                        <span>(advanced: 20–30 minutes)</span>. Minimum one
                        round; two or three rounds recommended as capacity
                        allows.
                      </p>
                    </div>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      Preparation
                    </h5>

                    <p className={styles.grey_bullet_cont}>
                      <span>Seat & posture:</span> Sit upright{" "}
                      <span>(cushion or chair)</span>. Pelvis neutral, spine
                      tall, crown gently ascending. Shoulders soft, jaw
                      unclenched, tongue resting on the palate.
                    </p>

                    <p className={styles.grey_bullet_cont}>
                      <span>Mudrā:</span> Jñāna or Chin mudrā{" "}
                      <span>(thumb–index lightly joined)</span>.
                    </p>

                    <p className={styles.grey_bullet_cont}>
                      <span>Gaze:</span> Eyes closed or half-lidded; rest
                      awareness at the crown.
                    </p>

                    <p className={styles.grey_bullet_cont}>
                      <span>Kabbalistic orientation (optional):</span> Take the
                      throne-seat of awareness as Kether{" "}
                      <span>(absolute unity)</span> at the crown, encircled by
                      the boundless Ain.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck24_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block24} alt="Block-24 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <h5 className={styles.yellow_bullet_and_cont}>
                      Core Imagery
                    </h5>
                    <div className={styles.padding_left}>
                      <p className={styles.grey_bullet_cont}>
                        <span>1 (Unity):</span> A hyper-focused, luminous
                        point—absolute singularity—at the crown{" "}
                        <span>
                          (or infinitesimal point in the center of the head)
                        </span>
                        .
                      </p>
                    </div>
                    <div className={styles.padding_left}>
                      <p className={styles.grey_bullet_cont}>
                        <span>0 (Boundlessness):</span> Infinite, edgeless{" "}
                        <span>“negative”</span> existence—limitless black open
                        space—surrounding all directions.
                      </p>
                    </div>

                    <h5 className={styles.yellow_bullet_and_cont}>Mantra</h5>
                    <div className={styles.padding_left}>
                      <p className={styles.grey_bullet_cont}>
                        <span>
                          Oṁ (A-U-M as one continuous, unforced resonance).
                        </span>{" "}
                        Vocal or whispered for beginners; mental for advanced
                        practice.
                      </p>
                    </div>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      Method (one round)
                    </h5>
                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>1.</h5>
                      <p>Establish the Witness (30–60 sec)</p>
                    </div>

                    <p className={styles.grey_bullet_cont}>
                      Settle the breath. Attend to the felt sense of{" "}
                      <span>“I-Am-Aware.”</span>
                    </p>

                    <p className={styles.grey_bullet_cont}>
                      Visualize the 1—a steady, brilliant point at the crown,
                      that becomes your identity. Sense the 0—boundless dark
                      openness encircling it.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck25_main}`}>
                <div className={styles.image_section}>
                  <Image src={block25} alt="Block-25 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>2.</h5>
                      <p>Resonant Exhale — Radiating Unity (Oṁ)</p>
                    </div>

                    <p className={styles.grey_bullet_cont}>
                      Exhale slowly while sounding <span>“Oṁ.”</span> As the
                      sound flows out, imagine the central 1 amplifying—its
                      luminosity gently pressing outward into the 0, pervading
                      the boundless field without losing its point-centered
                      integrity
                    </p>

                    <p className={styles.grey_bullet_cont}>
                      Keep simultaneous awareness: unity radiating and the
                      boundless receiving.
                    </p>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>3.</h5>
                      <p>
                        Suggested pacing: Exhale/Oṁ for ~6–10 seconds (or any
                        length that remains relaxed and resonant).
                      </p>
                    </div>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>4.</h5>
                      <p>Inhale — Recollecting to the Point</p>
                    </div>

                    <p className={styles.grey_bullet_cont}>
                      Inhale smoothly through the nose.As the breath returns,
                      gather all radiance back to the point—the 1 condenses
                      again at the crown/center, perfectly bright and unmixed,
                      centralizing in your entire being.
                    </p>

                    <p className={styles.grey_bullet_cont}>
                      Maintain the double-awareness: the 0 remains boundless;
                      the 1 is fully centered.
                    </p>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>5.</h5>
                      <p>Repeat</p>
                    </div>

                    <p className={styles.grey_bullet_cont}>
                      Complete 3 to 5 such resonations (steps 2–3), keeping the
                      Witness steady, the imagery clear, and the throat relaxed.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck26_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block26} alt="Block-26 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>6.</h5>
                      <p>Silent Holding (Seal)</p>
                    </div>

                    <p className={styles.grey_bullet_cont}>
                      After the final Oṁ, enter pure silence for 3 deep
                      breaths—no mantra, no manipulation.
                    </p>

                    <p className={styles.grey_bullet_cont}>
                      Simply abide as the 1 within the 0: unity perfectly
                      centered; boundlessness perfectly open.
                    </p>

                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>7.</h5>
                      <p>Completion or Next Round</p>
                    </div>

                    <p className={styles.grey_bullet_cont}>
                      Either conclude (see Closing) or repeat another
                      3–5-resonation round, maintaining ease.
                    </p>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      Closing (30–60 sec)
                    </h5>

                    <p className={styles.padding_left}>
                      Let the mantra and imagery dissolve.
                    </p>
                    <p className={styles.padding_left}>
                      Sense the after-glow of centered clarity.
                    </p>
                    <p className={styles.padding_left}>
                      If using the Kabbalistic frame, acknowledge Kether
                      enthroned in Ain.
                    </p>
                    <p className={styles.padding_left}>
                      Bow inwardly to the Witness.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.raja_kundalini_page_part4_main}>
            <div className={styles.blck_sec_common_width}>
              <div className={`${styles.blck1_main} ${styles.blck27_main}`}>
                <div className={styles.image_section}>
                  <Image src={block27} alt="Block-27 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <h5 className={styles.yellow_bullet_and_cont}>
                      Breath & Sound Notes
                    </h5>

                    <p className={styles.grey_bullet_cont}>
                      Keep Oṁ unforced and even with intoned clairity to where
                      you can hear the second octave above the sound of your
                      voice (volume moderate).
                    </p>

                    <p className={styles.grey_bullet_cont}>
                      If short of breath, shorten the Oṁ; if agitated, lengthen
                      exhale slightly.
                    </p>

                    <p className={styles.grey_bullet_cont}>
                      Mental Oṁ is appropriate when vocalization would disturb
                      steadiness.
                    </p>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      Troubleshooting & Cues
                    </h5>

                    <p className={styles.grey_bullet_cont}>
                      <span>Wandering mind:</span> Re-locate the 1 at the crown;
                      let stray thoughts appear as empty 0s that don’t touch the
                      point.
                    </p>

                    <p className={styles.grey_bullet_cont}>
                      <span>Over-effort:</span> Ease the throat/jaw; reduce the
                      length of Oṁ; return to natural breath for a few cycles.
                    </p>

                    <p className={styles.grey_bullet_cont}>
                      <span>Dullness:</span> Enliven the point—brighten the 1
                      subtly; sit a bit taller; refresh the felt Witness.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck28_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block28} alt="Block-28 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h4 className={styles.green_heading_25}>
                    Entering the Śiva state of Pure Awareness
                  </h4>
                  <div className={styles.content_section}>
                    <p>
                      You are now ready to enter the pure Śiva state—the final
                      meditation of Raja
                    </p>

                    <h4 className={styles.yellow_heading_20}>
                      Preparatory Posture and Breath
                    </h4>

                    <p>
                      Seat yourself in a posture that establishes both stability
                      and openness.
                    </p>

                    <p className={styles.yellow_bullet_cont}>
                      Dragon Seat (vajrasana) or Lotus Seat (padmasana) are
                      recommended; if neither is comfortable, a straight-backed
                      chair with feet grounded may be used.
                    </p>

                    <p className={styles.yellow_bullet_cont}>
                      Rest the hands lightly on the knees or folded in the lap,
                      palms upward.
                    </p>

                    <p className={styles.yellow_bullet_cont}>
                      Straighten the spine so that the crown of the head rises
                      toward the heavens while the base is rooted firmly in the
                      earth.
                    </p>

                    <p>
                      Close the eyes. Breathe slowly and deeply, letting the
                      breath settle the body into stillness. Hold for a few
                      moments in inner readiness, gathering the senses inward.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck29_main}`}>
                <div className={styles.image_section}>
                  <Image src={block29} alt="Block-29 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <h5 className={styles.yellow_heading_20}>
                      The Practice of Śiva as Silence
                    </h5>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      <span style={{ color: "#ff9900" }}>Pronounce:</span>
                    </h5>
                    <div className={styles.padding_left}>
                      <p>
                        <span>
                          “I am Śiva, that which is not. I am silence, center of
                          consciousness, the knower.”
                        </span>
                      </p>
                      <p>
                        Bring the right index finger to the lips in the Sign of
                        Silence, sealing the intent.Breathe deeply for 1–2
                        minutes, letting awareness sharpen and settle.
                      </p>
                    </div>

                    <h5 className={styles.yellow_heading_20}>
                      Remove the Body
                    </h5>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      <span style={{ color: "#ff9900" }}>Pronounce:</span>
                    </h5>
                    <div className={styles.padding_left}>
                      <p>
                        <span>
                          “My body, an expression of my existence, but not I.”
                        </span>
                      </p>
                    </div>
                    <p className={styles.grey_bullet_cont}>
                      Take 3 deep breaths, perceiving the body as a temporary
                      expression of the I.
                    </p>
                    <p className={styles.grey_bullet_cont}>
                      Take 3 deep breaths, removing the body from your
                      awareness, gently setting it aside.
                    </p>

                    <h5 className={styles.yellow_heading_20}>Emotions</h5>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      <span style={{ color: "#ff9900" }}>Pronounce:</span>
                    </h5>
                    <div className={styles.padding_left}>
                      <p>
                        <span>
                          “My emotions, an expression of my existence, but not
                          I.”
                        </span>
                      </p>
                    </div>

                    <p className={styles.grey_bullet_cont}>
                      Take 3 deep breaths, perceiving the emotions as waves upon
                      the I.
                    </p>

                    <p className={styles.grey_bullet_cont}>
                      Take 3 deep breaths, removing the emotions from your
                      awareness, setting them aside.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck30_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block30} alt="Block-30 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <h5 className={styles.yellow_heading_20}>
                      Remove the Thoughts
                    </h5>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      <span style={{ color: "#ff9900" }}>Pronounce:</span>
                    </h5>
                    <div className={styles.padding_left}>
                      <p>
                        <span>
                          “My thoughts, an expression of my existence, but not
                          I.”
                        </span>
                      </p>
                    </div>
                    <p className={styles.grey_bullet_cont}>
                      Take 3 deep breaths, perceiving thoughts as movements
                      through the I.
                    </p>
                    <p className={styles.grey_bullet_cont}>
                      Take 3 deep breaths, removing the thoughts from your
                      awareness, setting them aside.
                    </p>

                    <h5 className={styles.yellow_heading_20}>Remove Life</h5>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      <span style={{ color: "#ff9900" }}>Pronounce:</span>
                    </h5>
                    <div className={styles.padding_left}>
                      <p>
                        <span>
                          “My life, an expression of my existence, but not I.”
                        </span>
                      </p>
                    </div>
                    <p className={styles.grey_bullet_cont}>
                      Take 3 deep breaths, perceiving the conditions of life as
                      patterns upon the I.
                    </p>
                    <p className={styles.grey_bullet_cont}>
                      Take 3 deep breaths, removing all the details of your life
                      from awareness, setting them aside.
                    </p>

                    <h5 className={styles.yellow_heading_20}>
                      Remove Time and Space
                    </h5>

                    <h5 className={styles.yellow_bullet_and_cont}>
                      <span style={{ color: "#ff9900" }}>Pronounce:</span>
                    </h5>
                    <div className={styles.padding_left}>
                      <p>
                        <span>
                          {" "}
                          “I am Awareness. I am Silence. Śiva, the knower, the
                          observer, infinite, eternal.”
                        </span>
                      </p>
                    </div>

                    <p className={styles.grey_bullet_cont}>
                      Take 3 deep breaths, perceiving time and space themselves
                      as expressions of the I.
                    </p>
                    <p className={styles.grey_bullet_cont}>
                      Take 3 deep breaths, removing time and space from your
                      awareness, setting them aside.
                    </p>

                    <h5 className={styles.yellow_heading_20}>
                      Abidance in Pure Silence
                    </h5>

                    <p>
                      Remain as long as possible in this state.Merge into the
                      consciousness of Śiva—pure silence, pure awareness—where
                      the “I” that you are is the very “I” of the Great Lord.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div
            className={`${styles.kria_kundalini_part_main} ${styles.raja_kundalini_page_part5_main}`}
          >
            <div class={styles.common_width}>
              <div className={styles.orange_heading_section}>
                <div
                  className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
                >
                  <div className={styles.column}>
                    <div className={`${styles.col12} ${styles.bgifive}`}>
                      <h1>Kria Kundalini preparation of the physical</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.blck_sec_common_width}>
              <div className={`${styles.blck1_main} ${styles.blck31_main}`}>
                <div className={styles.image_section}>
                  <Image src={block31} alt="Block-31 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <span>
                        Tantric Kundalini Yoga engages three primary modes of
                        practice: physical activation, energetic embodiment,
                      </span>{" "}
                      and <span>sexual engagement</span>. Each of these aspects
                      serves a specific role in awakening and circulating the
                      vital life force (Kundalini) throughout the body and
                      subtle system.
                    </p>

                    <p>
                      In this training, we will be focusing exclusively on the{" "}
                      <span>first two domains—physical preparation (Kria)</span>{" "}
                      and <span>embodied energetic awakening (Chakra)</span>.
                      These are foundational and can be practiced safely and
                      effectively by individuals at all stages of their journey.
                      They work in harmony to cleanse, awaken, and refine the
                      channels of the body, laying the groundwork for deeper
                      transformation.
                    </p>

                    <p>
                      The third domain—<span>sexual engagement</span>—is a
                      potent and sacred aspect of Tantric practice. However, due
                      to its intimate and highly individualized nature, we
                      encourage{" "}
                      <span>
                        adult practitioners with informed consent and willing
                        partners
                      </span>{" "}
                      to explore that dimension privately, with discernment and
                      respect. It is a path that, while powerful, requires deep
                      maturity, mutual trust, and a strong grounding in the
                      preparatory stages.
                    </p>

                    <p>Our aim here is to offer tools and teachings that bring <span>clarity, presence, and energetic alignment</span> through the physical and embodiment practices of Tantric Kundalini Yoga.<br></br> Before engaging the subtle centers of the body in chakra work or theurgical ritual, the <span>physical body must be awakened, loosened, and primed through</span> Kria Kundalini. Energy flows most effectively through a body that is alert, breath-activated, and aligned. The following preparatory sequence is designed to:</p>

                    <div className={styles.sky_blue_box}>
                      <div className={styles.yellow_box}>
                        <h5 className={`${styles.yellow_bullet_and_cont} ${styles.black_bullet_and_cont}`} style={{color: "#000000"}}>Unstiffen the spine and shoulders</h5>
                        <h5 className={`${styles.yellow_bullet_and_cont} ${styles.black_bullet_and_cont}`} style={{color: "#000000"}}>Energize the breath and pranic force</h5>
                        <h5 className={`${styles.yellow_bullet_and_cont} ${styles.black_bullet_and_cont}`} style={{color: "#000000"}}>Stimulate deep bodily awareness</h5>
                        <h5 className={`${styles.yellow_bullet_and_cont} ${styles.black_bullet_and_cont}`} style={{color: "#000000"}}>End in a pleasurable, surrendered state</h5>
                      </div>
                      <p style={{color: "#ffffff"}}>This is not just <span style={{color: "#fff000"}}>“warm-up.”</span> This is somatic invocation—an energetic preparation for spiritual embodiment.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck32_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block32} alt="Block-32 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <h5 className={styles.green_heading_25}>The Breath of Fire</h5>

                    <p>For all exercises <span>except the last</span>, you will be using <span>Breath of Fire</span>: a <span>rapid series of deep inhalations through the nose</span>, powered from the diaphragm and belly. Each inhale should be full and swift, drawing the breath deeply into the body.  The exhale follows immediately and naturally, but without forcing.</p>

                    <p>Let the rhythm become steady and powerful—<span>a full-body breath that stokes your inner fire</span>. This breath is the primary engine of energetic awakening within the Kundalini system. It is not merely physiological—it is <span>sacred breathwork</span>, directing the flow of life-force through the subtle and physical body alike.</p>

                    <p>In all seven of the recommended Kundalini postures that follow, the mental focus should remain singular and steady: one process, one intention, one breath-mind.</p>
                  </div>

                  <div className={styles.sky_blue_box}>
                    <p className={`${styles.yellow_bullet_and_cont} ${styles.yellow_bullet_and_grey_cont}`} style={{fontWeight: "400", color: "#ffffff"}}>On each inhale, you are consciously drawing in prāna—the subtle, intelligent life-force that animates all living things. Prāna is morethan air; it is the vital current of consciousness itself, carried on the breath and absorbed into every cell. As you breathe it in,imagine this luminous energy filling your body with clarity, vitality, and power.</p>
                    <p className={`${styles.yellow_bullet_and_cont} ${styles.yellow_bullet_and_grey_cont}`} style={{fontWeight: "400", color: "#ffffff"}}>On each exhale, you are actively releasing all that is stuck, stagnant, or harmful within you—physically, emotionally, mentally, andenergetically. Let the out-breath carry away tightness, self-doubt, emotional residue, mental noise—anything that obstructs the free flowof your inner light.</p>
                  </div>

                  <div className={styles.content_section}>
                    <p>This rhythmic polarity—drawing in pure force, releasing inner obstruction—is the central alchemy of the practice. Let it guide you through each movement and posture. As the breath deepens and the energy circulates, the body begins to transform from the inside out, becoming a clear channel for awakened embodiment.</p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck33_main}`}>
                <div className={styles.image_section}>
                  <Image src={block33} alt="Block-33 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>1.</h5>
                      <h5 className={styles.yellow_heading_20}>Standing Anchoring Breath</h5>
                    </div>
                    <p><strong>Purpose:</strong> Activate the lower center and awaken the deep belly breath.</p>

                    <p className={styles.yellow_bullet_cont}>Stand upright, feet planted solidly beneath your hips.</p>
                    <p className={styles.yellow_bullet_cont}>Place both hands over your <span>lower abdomen</span>, just below the navel. This is your <span>anchor point</span>—your energetic root.</p>
                    <p className={styles.yellow_bullet_cont}>Begin <span>Breath of Fire</span> through the nose: <span>rapid but very deep inhalations</span>, drawing the breath into your belly so that your hands rise and fall.</p>
                    <p className={styles.yellow_bullet_cont}>Keep going until you reach your <span>edge</span>—when the fire has done its work.</p>

                    <p>At the end, take a <span>deep inhale</span>, hold the breath for several seconds, and place your <span>index finger gently over your lips</span> in the <span>Sign of Silence</span>. Let the energy still and settle.</p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck34_main} ${styles.flex_direction_reverse}`}>
                <div className={styles.image_section}>
                  <Image src={block34} alt="Block-34 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>2.</h5>
                      <h5 className={styles.yellow_heading_20}>Seated Accordion</h5>
                    </div>
                    <p><strong>Purpose:</strong> Mobilize the spine and midsection; clear blockages along the central channel.</p>

                    <p className={styles.yellow_bullet_cont}>Sit in <span>Lotus Pose (Padmasana)</span> or <span>Easy Pose (Sukhasana)</span> with your spine tall.</p>
                    <p className={styles.yellow_bullet_cont}>Take a fast inhale through the nose.</p>
                    <p className={styles.yellow_bullet_cont}>As you exhale, collapse the belly inward, <span>drawing the navel toward the spine, rounding the back,</span> and <span>pulling the shoulders down and forward</span>.</p>
                    <p className={styles.yellow_bullet_cont}>Inhale again and immediately <span>return upright</span>, spine tall like a tower.</p>

                    <p>Repeat this <span>accordion motion</span> several times using <span>deep, rapid breaths through the nose,</span> syncing the breath to the spinal movement.  End with a deep breath in, hold, finger to lips, and stillness.</p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck35_main}`}>
                <div className={styles.image_section}>
                  <Image src={block35} alt="Block-35 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>3.</h5>
                      <h5 className={styles.yellow_heading_20}>Seated Winged Twist</h5>
                    </div>
                    <p><strong>Purpose:</strong> Open the spine and shoulders through dynamic spiraling motion.</p>

                    <p className={styles.yellow_bullet_cont}>Stay seated. Place your <span>hands on your shoulders</span>, with your <span>elbows raised horizontally</span>, forming <span>“wings.”</span></p>
                    <p className={styles.yellow_bullet_cont}>Begin <span>Breath of Fire</span>, inhaling deeply and rapidly through the nose.</p>
                    <p className={styles.yellow_bullet_cont}>On each <span>inhale, twist the torso fully to the left</span>.</p>
                    <p className={styles.yellow_bullet_cont}>On each <span>exhale, twist fully to the right</span>.</p>

                    <p>Continue this rhythmic twisting for several rounds. Let the breath fuel the movement. End with an inhale, hold the breath, and finger to lips.</p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck36_main} ${styles.flex_direction_reverse}`}>
                <div className={styles.image_section}>
                  <Image src={block36} alt="Block-36 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>4.</h5>
                      <h5 className={styles.yellow_heading_20}>Arm Circles of Fire</h5>
                    </div>
                    <p><strong>Purpose:</strong> Activate the arms, chest, and shoulders, and circulate upper prana.</p>

                    <p className={styles.yellow_bullet_cont}>Remain seated. Extend your arms <span>straight out</span> to the sides, parallel to the floor, palms open.</p>
                    <p className={styles.yellow_bullet_cont}>Begin making <span>tight, fast circular motions</span> with your arms in one direction.</p>
                    <p className={styles.yellow_bullet_cont}>Use <span>deep, rapid inhalations through the nose (Breath of Fire)</span> throughout.</p>
                    <p className={styles.yellow_bullet_cont}>After a duration, <span>reverse the direction</span> of the circles and continue with the same breath.</p>

                    <p>This will generate <span>immense heat</span> and loosen energetic congestion in the heart and shoulders. At the end, inhale deeply, hold, and place finger to lips.</p>


                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>5.</h5>
                      <h5 className={styles.yellow_heading_20}>Standing Winged Twist</h5>
                    </div>
                    <p><strong>Purpose:</strong> Integrate the spinal twist into a grounded, vertical posture.</p>

                    <p className={styles.yellow_bullet_cont}>Now stand up, keeping your <span>hands on your shoulders</span>, elbows raised.</p>
                    <p className={styles.yellow_bullet_cont}>Begin <span>Breath of Fire</span> through the nose.</p>
                    <p className={styles.yellow_bullet_cont}>Inhale and <span>twist to the left</span>, exhale and <span>twist to the right</span>, just as before.</p>

                    <p>This version grounds the twisting into your legs and pelvis, energizing the full spinal column. Inhale at the end, hold, finger to lips.</p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck37_main}`}>
                <div className={styles.image_section}>
                  <Image src={block37} alt="Block-37 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>6.</h5>
                      <h5 className={styles.yellow_heading_20}>Lunge of Activation</h5>
                    </div>
                    <p><strong>Purpose:</strong> Ground the energy into the legs and hips while extending the breath and balance.</p>

                    <p className={styles.yellow_bullet_cont}>Step forward with one leg into a <span>deep lunge</span>, placing <span>all your weight</span> into the front foot.</p>
                    <p className={styles.yellow_bullet_cont}>Your back foot is <span>inverted</span>, the top resting lightly on the ground behind you.</p>
                    <p className={styles.yellow_bullet_cont}><span>Arms stretch out to the sides,</span> straight and firm.</p>
                    <p className={styles.yellow_bullet_cont}>Begin <span>Breath of Fire</span> through the nose in this position.</p>
                    <p className={styles.yellow_bullet_cont}>Hold steady while the breath pumps vitality into your root and solar centers.</p>

                    <p>After a strong duration, <span>switch legs</span> and repeat.<br></br> End each side with a deep breath in, hold, finger to lips.</p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck38_main} ${styles.flex_direction_reverse}`}>
                <div className={styles.image_section}>
                  <Image src={block38} alt="Block-38 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <div className={styles.flex_numb_cont}>
                      <h5 className={styles.yellow_number}>7.</h5>
                      <h5 className={styles.yellow_heading_20}>HAD! Discharge and Relaxation</h5>
                    </div>
                    <p><strong>Purpose:</strong> Discharge all effort and awaken pleasure through complete release.</p>
                    <p>This final practice is <span>not done with Breath of Fire</span>, but with <span>loud, forceful sound and physical release</span>.</p>

                    <p className={styles.yellow_bullet_cont}>Lie <span>flat on your back</span>, legs <span>extended straight</span> and held <span>about a foot off the ground</span>.</p>
                    <p className={styles.yellow_bullet_cont}>Arms lie at your sides, palms open.</p>
                    <p className={styles.yellow_bullet_cont}>In rhythm, lift the arms several feet, then <span>strike them firmly but safely onto the floor</span> as you loudly shout: <span>“HAD!”</span></p>
                    <p className={styles.yellow_bullet_cont}>Repeat in <span>quick succession</span>: strike, shout, strike, shout—over and over.</p>

                    <p><span>Continue until you absolutely cannot go any further.</span><br></br> Then stop.</p>

                    <p>Let the <span>entire body fall limp</span>. Lie <span>completely still</span>, letting pleasure and pulsation <span>flood through the nervous system</span>.<br></br> Breathe gently. Receive.</p>
                  </div>
                  
                  <h5 className={styles.green_heading_25}>Daily Practice & Ritual Use</h5>

                  <div className={styles.content_section}>
                    <p>This sequence can be practiced <span>on its own as a daily energetic hygiene</span>, or used <span>before chakra alignment rituals and theurgical practice</span>.</p>

                    <p>At the very least, we <span>recommend Exercise 1 daily</span> before engaging in any spiritual or chakra-based work.</p>

                    <p>This is how you make the body into a <span>temple of presence</span>—not by bypassing it, but by <span>awakening it</span>.</p>

                    <p>A loose spine, open chest, and breathing belly are not just health benefits—they are <span>spiritual conditions</span> that prepare the inner being for transformation.</p>

                    <p>When the body becomes breath, and the breath becomes fire, and the fire becomes silence, the chakras open naturally.</p>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <div
            className={`${styles.tantric_kundalini_part_main} ${styles.raja_kundalini_page_part6_main}`}
          >
            <div class={styles.common_width}>
              <div className={styles.orange_heading_section}>
                <div
                  className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
                >
                  <div className={styles.column}>
                    <div className={`${styles.col12} ${styles.bgifive}`}>
                      <h1>
                        Tantric Kundalini: The Shakti Path of Unfolding Eternity
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.blck_sec_common_width}>
              <div className={`${styles.blck1_main} ${styles.blck39_main}`}>
                <div className={styles.image_section}>
                  <Image src={block39} alt="Block-39 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      Once the stable centrality of Raja-Kundalini has been
                      established—where the practitioner is no longer subject to
                      the dissipation of awareness, but has become a still point
                      of awakened observation—a new phase begins. This phase is
                      not merely one of continuation, but of ignition. It is the
                      Tantric phase of Kundalini proper: the embodied ascent of
                      the sacred current of Shakti through the internal cosmos
                      of the subtle body, toward union with pure awareness,
                      Śiva.
                    </p>

                    <p>
                      At this stage, the practice of Kundalini Yoga is not
                      simply a spiritual exercise—it becomes the map and motion
                      of divine transfiguration. The Raja current has gathered
                      the awareness into the center; now the Tantric current,
                      rising from the depths, begins to spiral through the
                      energetic pathways of the being, awakening the Goddess in
                      each sphere of consciousness, opening gateways in the
                      body, psyche, and spirit.
                    </p>

                    <p>
                      As Abhinavagupta writes in the{" "}
                      <span>
                        <i>Tantrāloka,</i>
                      </span>{" "}
                      this is not a metaphorical path but a dynamic reality in
                      which:
                    </p>

                    <p>
                      <span>
                        "When the light of consciousness, having been made free
                        from the constrictions of limited knowing, surges upward
                        along the central channel (suṣumṇā), all the divine
                        energies arise to meet it, as brides to their
                        bridegroom. In this ascent, the yogin becomes
                        Bhairava—one with the ecstatic pulse of the Infinite."
                        (Tantrāloka I.266–267, paraphrased)
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck40_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block40} alt="Block-40 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      This ascent is not linear, but rhythmic and spiralic,
                      awakening entire worlds—lokas—within each chakra. In the
                      authentic Tantric view, the chakras are not abstract
                      symbols or mere physiological points of attention. They
                      are living mandalic realities, each presided over by its
                      own goddess, a Shakti who governs a domain of experience,
                      emotion, and consciousness. They are worlds within, and
                      gates to the worlds beyond.
                    </p>

                    <p>As Jung observed:</p>

                    <p>
                      <span>
                        "The chakras are not merely centers of psychic function,
                        but entire symbolic realities. Each one is a mandala, a
                        world in itself, and represents a level of psychic
                        integration which the practitioner must realize."
                      </span>
                    </p>

                    <p>
                      <span>
                        <i>(The Psychology of Kundalini Yoga)</i>
                      </span>
                    </p>

                    <p>
                      In this view, the Kundalini-Shakti is not merely a{" "}
                      <span>"force"</span> but the very dynamism of Reality, the
                      latent divine intelligence curled at the base of the
                      spine—kula-kundalinī—as described in Tantrāloka VI.67:
                    </p>

                    <p>
                      <span>
                        “She is the luminous serpent, the secret mother of the
                        gods, whose upward surge carries the yogin beyond even
                        the devas, to the point where no division remains.”
                      </span>
                    </p>

                    <p>
                      As she rises, this divine Power does not simply pass
                      through points but transforms the{" "}
                      <span>very substratum</span> of the individual’s being.
                      Each chakra is both a stage of psychological integration
                      and a metaphysical transformation. Through ritual
                      visualization, mantra, breath, mudrā, and sustained
                      meditative engagement, the practitioner learns not only to{" "}
                      <span>“open”</span> these centers, but to become them—to
                      live from their awakened intelligence.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck41_main}`}>
                <div className={styles.image_section}>
                  <Image src={block41} alt="Block-41 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      To awaken and ascend the Kundalinī Shakti is not merely to
                      alter consciousness—it is to divinize perception, to
                      reweave identity from the inside out.
                    </p>

                    <p>
                      <span>
                        “For the yogin, the Shakti is no longer unconscious
                        nature. She is now his own inner light of becoming.”{" "}
                        <br></br>(Tantrāloka, paraphrased)
                      </span>
                    </p>

                    <p>
                      This is where Jung’s insight becomes profoundly relevant
                      to our tradition. In his analysis, the entire journey of
                      Kundalinī becomes a process of integrating the
                      unconscious—a psychic alchemy leading to individuation.
                      Śiva is the ego-consciousness, the{" "}
                      <span>
                        <i>witnessing</i>
                      </span>{" "}
                      I, and Shakti is the dynamic unconscious, the vast field
                      of subtle and suprapersonal powers. Their union, in
                      Sahasrāra, is the integration of conscious and
                      unconscious, matter and spirit, body and soul.
                    </p>

                    <p>
                      <span>
                        “The aim of Tantra,” Jung says, “is to connect the
                        conscious ego with the specific nature of the non-ego,
                        which is impersonality itself… this produces the light
                        of a higher, suprapersonal consciousness.” <br></br>(The
                        Psychology of Kundalini Yoga)
                      </span>
                    </p>

                    <p>
                      This echoes the very heart of our practice. Raja-Kundalini
                      creates the axis of centrality—the vertical spine of pure
                      awareness. Tantric Kundalini then animates that axis with
                      divine motion, drawing up the latent Shakti through each
                      psychic world until the supreme union of Śiva-Shakti is
                      tasted in the thousand-petaled lotus,{" "}
                      <span>Sahasrāra, which, according to Tantrāloka</span>{" "}
                      X.35:
                    </p>

                    <p>
                      <span>
                        “...is not a chakra, but the sun of suns, the radiant
                        void where all opposites dissolve into blissful
                        indivisibility.”
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.double_image_section_main}>
              <div className={styles.block42_bg_wrpr}>
                <div className={styles.blck_sec_common_width}>
                  <div
                    className={`${styles.blck1_main} ${styles.blck42_main} ${styles.flex_direction_reverse}`}
                  >
                    <div className={styles.image_section}>
                      <Image
                        className={styles.muladhara_red}
                        src={muladharaRed}
                        alt="Block-42 Image"
                      />
                      <Image
                        className={styles.muladhara_red_character}
                        src={muladharaRedCharacter}
                        alt="Block-42 Image"
                      />
                      <div className={styles.root_chkra}>
                        <p>Root CHAKRA</p>
                      </div>
                    </div>
                    <div className={styles.content_section_main}>
                      <div className={styles.content_section}>
                        <p>
                          In this supreme moment, the yogin becomes not merely
                          one who{" "}
                          <span>
                            <i>experiences</i>
                          </span>{" "}
                          the Divine, but one who is the Divine, the infinite
                          pulsing through finite form. This is the crown of
                          Raja-Kundalini: the realization of the One through the
                          Two, the integration of centered consciousness{" "}
                          <span>(Raja)</span> with rising power{" "}
                          <span>(Kundalini)</span>, becoming the embodied axis
                          of heaven and earth.
                        </p>

                        <h5 className={styles.yellow_heading_20}>
                          The Seven Embodiments of Kundalini
                        </h5>

                        <p>
                          Each of these mantras is intoned fully three times
                          with a deep breath and the{" "}
                          <span>
                            <i>Sign of Silence</i>
                          </span>{" "}
                          between each recitation. This silence is not mere
                          absence—it is the womb of{" "}
                          <span>
                            <i>Spanda</i>
                          </span>
                          , the primordial vibration. As you focus on each
                          chakra from the root to the crown, hold the living
                          image of that chakra in your imaginal body, moving up
                          the spine as if ascending a sacred ladder of worlds.
                          Let each chakra be a full embodiment—not merely a
                          center, but a conscious world—while the others remain
                          like luminous nodes, alive in potential, humming in
                          the background.
                        </p>

                        <div className={styles.flex_numb_cont}>
                          <h5 className={styles.yellow_number}>1.</h5>
                          <p style={{ color: "#ffeb00" }}>
                            Mulādhāra (Root Chakra) — Grounding Meditation
                          </p>
                        </div>

                        <p>
                          <strong>Location:</strong> Base of the spine
                        </p>
                        <p>
                          <strong>Color:</strong> Deep Crimson-Red
                        </p>
                        <p>
                          <strong>Meaning:</strong> Physical identity,
                          stability, survival
                        </p>
                        <p>
                          <strong>Pronouncement:</strong>{" "}
                          <span>
                            <i>
                              I am connected and rooted in the earth. I am
                              stable.
                            </i>
                          </span>
                        </p>
                        <p className={styles.break_word}>
                          <strong>Resonance:</strong> Llllllaaaaaaammmmmmmmmmmm
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.double_image_bg_section}>
                <div className={styles.block43_bg_wrpr}>
                  <div className={styles.blck_sec_common_width}>
                    <div
                      className={`${styles.blck1_main} ${styles.blck43_main}`}
                    >
                      <div className={styles.image_section}>
                        <Image
                          className={styles.muladhara_sacral}
                          src={muladharaSacral}
                          alt="Block-43 Image"
                        />
                        <Image
                          className={styles.muladhara_sacral_character}
                          src={muladharaSacralCharacter}
                          alt="Block-43 Image"
                        />
                        <div className={styles.root_chkra}>
                          <p>SACRAL CHAKRA</p>
                        </div>
                      </div>
                      <div className={styles.content_section_main}>
                        <div className={styles.content_section}>
                          <h5 className={styles.yellow_heading_20}>
                            Visualization and Commentary:
                          </h5>

                          <p>
                            Enter the kṣetra of Mulādhāra as though descending
                            into the sacred cavern beneath the temple of your
                            being. This is the root of embodiment, the anchor of
                            individuality{" "}
                            <span>
                              <i>(aham)</i>
                            </span>
                            . Here, Śakti slumbers as the coiled serpent—
                            <span>
                              <i>Kuṇḍalinī,</i>
                            </span>{" "}
                            latent divinity awaiting awakening. Visualize a
                            glowing red sphere at the base of the spine,
                            pulsating with ancestral memory and earthly
                            vitality. In this center, you are not merely
                            grounded—you are the seed of the whole tree of
                            theurgy. Let the mantra <span>"Lam"</span> vibrate
                            down into the marrow of your bones, invoking the
                            presence of the Earth as sacred matter{" "}
                            <span>
                              <i>(pṛthivī tattva)</i>
                            </span>
                            .
                          </p>

                          <div className={styles.flex_numb_cont}>
                            <h5 className={styles.yellow_number}>2.</h5>
                            <p style={{ color: "#ffeb00" }}>
                              Svādhiṣṭhāna (Sacral Chakra) —{" "}
                              <i>Creative Meditation</i>
                            </p>
                          </div>

                          <p>
                            <strong>Location:</strong> Below the navel
                          </p>
                          <p>
                            <strong>Color:</strong> Vivid Orange
                          </p>
                          <p>
                            <strong>Meaning:</strong> Sensuality, creativity,
                            fluidity
                          </p>
                          <p>
                            <strong>Pronouncement:</strong>{" "}
                            <span>
                              <i>
                                I am potent with the passions of life, in
                                control and directed
                              </i>
                            </span>
                          </p>
                          <p className={styles.break_word}>
                            <strong>Resonance:</strong>{" "}
                            Vvvvvaaaaaaammmmmmmmmmmmmm
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block44_bg_wrpr}>
                  <div className={styles.blck_sec_common_width}>
                    <div
                      className={`${styles.blck1_main} ${styles.blck44_main} ${styles.flex_direction_reverse}`}
                    >
                      <div className={styles.image_section}>
                        <Image
                          className={styles.solar_plexus}
                          src={solarPlexus}
                          alt="Block-44 Image"
                        />
                        <Image
                          className={styles.solar_plexus_character}
                          src={solarPlexusCharacter}
                          alt="Block-44 Image"
                        />
                        <div className={styles.root_chkra}>
                          <p>SOLAR PLEXUS CHAKRA</p>
                        </div>
                      </div>
                      <div className={styles.content_section_main}>
                        <div className={styles.content_section}>
                          <h5 className={styles.yellow_heading_20}>
                            Visualization and Commentary:
                          </h5>

                          <p>
                            Now rise into the shimmering waters of Svādhiṣṭhāna.
                            This is the place of sacred desire{" "}
                            <span>
                              <i>(kāma)</i>
                            </span>{" "}
                            and primal flow{" "}
                            <span>
                              <i>(rasa)</i>
                            </span>
                            , the seat of lunar movement and the erotic pulse of
                            Śakti. Visualize an orange, sunlit sphere in your
                            lower abdomen, spinning like a wheel of nectar. Feel
                            the energy drawn from the grounded root begin to
                            spiral, moving sensually upward, awakening the
                            creative fire within. This is not indulgence but
                            directed desire—Kāmadeva’s bow aimed toward the
                            Infinite. You begin to feel the{" "}
                            <span>
                              <i>saṃskāras</i>
                            </span>{" "}
                            of your own life as threads woven in the tapestry of
                            universal longing.
                          </p>

                          <div className={styles.flex_numb_cont}>
                            <h5 className={styles.yellow_number}>3.</h5>
                            <p style={{ color: "#ffeb00" }}>
                              Maṇipūra (Solar Plexus Chakra) — Power Meditation
                            </p>
                          </div>

                          <p>
                            <strong>Location:</strong> Navel/solar plexus
                          </p>
                          <p>
                            <strong>Color:</strong> Radiant Yellow
                          </p>
                          <p>
                            <strong>Meaning:</strong> Willpower, self-esteem,
                            identity
                          </p>
                          <p>
                            <strong>Pronouncement:</strong>{" "}
                            <span>
                              <i>
                                I am centered in my personal power; my world
                                revolves around me.
                              </i>
                            </span>
                          </p>
                          <p className={styles.break_word}>
                            <strong>Resonance:</strong>{" "}
                            Rrrrrrrraaaaaaaammmmmmmmmm
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block45_bg_wrpr}>
                  <div className={styles.blck_sec_common_width}>
                    <div
                      className={`${styles.blck1_main} ${styles.blck45_main}`}
                    >
                      <div className={styles.image_section}>
                        <Image
                          className={styles.heart}
                          src={heart}
                          alt="Block-45 Image"
                        />
                        <Image
                          className={styles.heart_character}
                          src={heartCharacter}
                          alt="Block-45 Image"
                        />
                        <div className={styles.root_chkra}>
                          <p>HEART CHAKRA</p>
                        </div>
                      </div>
                      <div className={styles.content_section_main}>
                        <div className={styles.content_section}>
                          <h5 className={styles.yellow_heading_20}>
                            Visualization and Commentary:
                          </h5>

                          <p>
                            Entering Maṇipūra is entering the chamber of fire—
                            <span>
                              <i>tejas tattva</i>
                            </span>
                            —the brilliant forge where the I is forged in golden
                            light. Visualize a golden-yellow sphere in the solar
                            plexus, glowing with resolve. From the ocean of
                            Svādhiṣṭhāna rises a disciplined flame. Here, your
                            will{" "}
                            <span>
                              <i>(icchā śakti)</i>
                            </span>{" "}
                            is clarified, and your sense of personal sovereignty
                            is awakened. This is the Sun within—Bhānu
                            maṇḍala—centered yet vast. Let the mantra "Ram"
                            resound like a war-drum of clarity, stabilizing you
                            as the royal witness of your experience, a
                            theurgist/yogi preparing for divine invocation.
                          </p>

                          <div className={styles.flex_numb_cont}>
                            <h5 className={styles.yellow_number}>4.</h5>
                            <p style={{ color: "#ffeb00" }}>
                              Anāhata (Heart Chakra) —{" "}
                              <i>Loving-Kindness Meditation</i>
                            </p>
                          </div>

                          <p>
                            <strong>Location:</strong> Center of the chest
                          </p>
                          <p>
                            <strong>Color:</strong> Emerald Green
                          </p>
                          <p>
                            <strong>Meaning:</strong> Love, compassion,
                            equilibrium
                          </p>
                          <p>
                            <strong>Pronouncement:</strong>{" "}
                            <span>
                              <i>
                                {" "}
                                I am compassionate and love openly. I welcome
                                others with kindness.
                              </i>
                            </span>
                          </p>
                          <p className={styles.break_word}>
                            <strong>Resonance:</strong>{" "}
                            Yyyyyyyaaaaaaaaaammmmmmmm
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block46_bg_wrpr}>
                  <div className={styles.blck_sec_common_width}>
                    <div
                      className={`${styles.blck1_main} ${styles.blck46_main} ${styles.flex_direction_reverse}`}
                    >
                      <div className={styles.image_section}>
                        <Image
                          className={styles.throat}
                          src={throat}
                          alt="Block-46 Image"
                        />
                        <Image
                          className={styles.throat_character}
                          src={throatCharacter}
                          alt="Block-46 Image"
                        />
                        <div className={styles.root_chkra}>
                          <p>THROAT CHAKRA</p>
                        </div>
                      </div>
                      <div className={styles.content_section_main}>
                        <div className={styles.content_section}>
                          <h5 className={styles.yellow_heading_20}>
                            Visualization and Commentary:
                          </h5>

                          <p>
                            Anāhata is the unstruck sound—the vibration that was
                            never caused but always is. Visualize a radiant
                            green sphere at the heart center, expanding like a
                            lotus of twelve petals. This is where individual
                            will and universal compassion embrace. The energies
                            of fire now find their serenity, merging with the
                            rhythm of the cosmos. As you chant{" "}
                            <span>"Yam,"</span> feel this mantra lifting your
                            being into higher resonance, allowing the divine
                            breath to animate your compassion. This is the first
                            true center of Theurgic Reciprocity, where love
                            becomes an offering and a mirror of divine union.
                          </p>

                          <div className={styles.flex_numb_cont}>
                            <h5 className={styles.yellow_number}>5.</h5>
                            <p style={{ color: "#ffeb00" }}>
                              Viśuddha (Throat Chakra) —{" "}
                              <i>Expression Meditation</i>
                            </p>
                          </div>

                          <p>
                            <strong>Location:</strong> Throat
                          </p>
                          <p>
                            <strong>Color:</strong> Azure Blue
                          </p>
                          <p>
                            <strong>Meaning:</strong> Expression, sound,
                            purification
                          </p>
                          <p>
                            <strong>Pronouncement:</strong>{" "}
                            <span>
                              <i>
                                I speak clearly and honestly, my voice is
                                aligned with Truth.
                              </i>
                            </span>
                          </p>
                          <p className={styles.break_word}>
                            <strong>Resonance:</strong> Hhhaaaaaaaaaammmmmmmmmmm
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block47_bg_wrpr}>
                  <div className={styles.blck_sec_common_width}>
                    <div
                      className={`${styles.blck1_main} ${styles.blck47_main}`}
                    >
                      <div className={styles.image_section}>
                        <Image
                          className={styles.third_eye}
                          src={thirdEye}
                          alt="Block-47 Image"
                        />
                        <Image
                          className={styles.third_eye_character}
                          src={thirdEyeCharacter}
                          alt="Block-47 Image"
                        />
                        <div className={styles.root_chkra}>
                          <p>THIRD EYE CHAKRA</p>
                        </div>
                      </div>
                      <div className={styles.content_section_main}>
                        <div className={styles.content_section}>
                          <h5 className={styles.yellow_heading_20}>
                            Visualization and Commentary:
                          </h5>

                          <p>
                            Viśuddha is the luminous sky within, the etheric
                            expanse{" "}
                            <span>
                              <i>(ākāśa tattva)</i>
                            </span>{" "}
                            of sacred expression. Visualize a glowing blue
                            sphere at the throat, pulsing like the inner bell of
                            truth. Here speech{" "}
                            <span>
                              <i>(vāg devī)</i>
                            </span>{" "}
                            becomes mantra, and sound becomes rite. This is not
                            casual communication—it is śabda brahman, the Word
                            as Cosmos. Chant <span>"Ham"</span> to attune your
                            speech with the divine Logos. As the energies rise
                            through love into sound, you become the voice of the
                            Divine within form. Every word you utter becomes a
                            thread in the fabric of ritual consciousness.
                          </p>

                          <div className={styles.flex_numb_cont}>
                            <h5 className={styles.yellow_number}>4.</h5>
                            <p style={{ color: "#ffeb00" }}>
                              Ājñā (Third Eye Chakra) —{" "}
                              <i>Intuition Meditation</i>
                            </p>
                          </div>

                          <p>
                            <strong>Location:</strong> Between the eyebrows
                          </p>
                          <p>
                            <strong>Color:</strong> Indigo
                          </p>
                          <p>
                            <strong>Meaning:</strong> Inner vision, gnosis,
                            insight
                          </p>
                          <p>
                            <strong>Pronouncement:</strong>{" "}
                            <span>
                              <i>
                                {" "}
                                I see clearly through the Eye of the Spirit. I
                                am vision.
                              </i>
                            </span>
                          </p>
                          <p className={styles.break_word}>
                            <strong>Resonance:</strong> Ooooooommmmmmmmmm
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block48_bg_wrpr}>
                  <div className={styles.blck_sec_common_width}>
                    <div
                      className={`${styles.blck1_main} ${styles.blck48_main} ${styles.flex_direction_reverse}`}
                    >
                      <div className={styles.image_section}>
                        <Image
                          className={styles.crown}
                          src={crown}
                          alt="Block-48 Image"
                        />
                        <Image
                          className={styles.crown_character}
                          src={crownCharacter}
                          alt="Block-48 Image"
                        />
                        <div className={styles.root_chkra}>
                          <p>CROWN CHAKRA</p>
                        </div>
                      </div>
                      <div className={styles.content_section_main}>
                        <div className={styles.content_section}>
                          <h5 className={styles.yellow_heading_20}>
                            Visualization and Commentary:
                          </h5>

                          <p>
                            Rise now into the twin petals of the{" "}
                            <span>
                              <i>Ājñā cakra</i>
                            </span>
                            , the gateway of gnosis. Visualize an indigo sphere
                            between your brows, glowing like the inner sun
                            behind all appearances. This is the chakra of
                            clairvoyance and command, where the yogic seer
                            perceives the weaving of worlds. The truth of the
                            throat has risen into the truth of{" "}
                            <span>dṛṣṭi</span>—vision. Here duality begins to
                            dissolve, and the inner Witness{" "}
                            <span>
                              <i>(sākṣin)</i>
                            </span>{" "}
                            comes into clarity. Resonate the syllable{" "}
                            <span>“Om,”</span> the primal vibration of the
                            cosmos, and feel the veil between worlds thin. This
                            is the eye of Śiva—the eye that burns illusion.
                          </p>

                          <div className={styles.flex_numb_cont}>
                            <h5 className={styles.yellow_number}>5.</h5>
                            <p style={{ color: "#ffeb00" }}>
                              Sahasrāra (Crown Chakra) —{" "}
                              <i>Divine Union Meditation</i>
                            </p>
                          </div>

                          <p>
                            <strong>Location:</strong> Top of the head
                          </p>
                          <p>
                            <strong>Color:</strong> Violet, White, or
                            Translucent Light
                          </p>
                          <p>
                            <strong>Meaning:</strong> Pure awareness, cosmic
                            intelligence
                          </p>
                          <p>
                            <strong>Pronouncement:</strong>{" "}
                            <span>
                              <i>
                                I am one with all life. I am That. I am the
                                Light itself.
                              </i>
                            </span>
                          </p>
                          <p className={styles.break_word}>
                            <strong>Resonance:</strong>{" "}
                            Nnnnnnnngggggggmmmmmmmmmmm
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block49_bg_wrpr}>
                  <div className={styles.blck_sec_common_width}>
                    <div className={`${styles.blck1_main} ${styles.blck49_main}`}>
                      <div className={styles.image_section}>
                        <Image src={block49} alt="Block-49 Image" />
                      </div>
                      <div className={styles.content_section_main}>
                        <div className={styles.content_section}>
                          <h5 className={styles.yellow_heading_20}>Visualization and Commentary:</h5>

                          <p>Sahasrāra is not merely a chakra—it is the thousand-petaled lotus of infinity <span><i>(sahasra-dala-padma)</i></span>, the great    aperture   through which the cit-śakti of the universe flows. Visualize a radiant field of violet-white light above the crown of your head.   This is  where Kuṇḍalinī, now awakened, re-unites with Śiva, the still and transcendent. Here, time, space, form, and identity collapse    into pure   radiance. This is the apex of the spiral—vimarśa reabsorbed into prakāśa, the knower into knowing. Rest in silence, not as    absence, but as  boundless plenitude, the silence of God within God.</p>

                          <p>Let this ascent not be merely a sequence, but a spiral dance, where every cycle brings new depth. The body is the temple, and this     ritual  is its awakening. Each chakra is not a step away from the world, but a portal into the Divine within the world. When practiced    regularly,  this meditation becomes a ladder of light, preparing the practitioner for the full sacramental rhythm of Theurgy.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="banner_modal_main"
        >
          <Box className="banner_modal_box">
            <Typography
              id="modal-modal-description"
              component="div"
              sx={{ mt: 2 }}
              className="modal_banner"
            >
              <div className="sub_modal_banner">
                <span className="close_btn" onClick={handleClose}>
                  <CloseIcon />
                </span>
                <img
                  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                  alt="bannerLogo"
                />
              </div>
            </Typography>
          </Box>
        </Modal>
      </div>
    </>
  );
}

export default index;
